var map = {
	"../Accouting/AccountingPeriod/AccountingPeriod.module": [
		"./src/app/Accouting/AccountingPeriod/AccountingPeriod.module.ts",
		"Accouting-AccountingPeriod-AccountingPeriod-module"
	],
	"../Accouting/BankStatement/BankStatement.module": [
		"./src/app/Accouting/BankStatement/BankStatement.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~a09e614a",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~b316c606",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~366bfa2a",
		"common",
		"Accouting-BankStatement-BankStatement-module"
	],
	"../Accouting/NewTaxExemption/new-taxexemption/new-taxexemption.module": [
		"./src/app/Accouting/NewTaxExemption/new-taxexemption/new-taxexemption.module.ts",
		"Accouting-NewTaxExemption-new-taxexemption-new-taxexemption-module"
	],
	"../Accouting/account-dashboard/account-dashboard.module": [
		"./src/app/Accouting/account-dashboard/account-dashboard.module.ts",
		"Accouting-account-dashboard-account-dashboard-module"
	],
	"../Accouting/accounting-period-new/accounting-period-new.module": [
		"./src/app/Accouting/accounting-period-new/accounting-period-new.module.ts",
		"Accouting-accounting-period-new-accounting-period-new-module"
	],
	"../Accouting/approvals/approvals.module": [
		"./src/app/Accouting/approvals/approvals.module.ts",
		"Accouting-approvals-approvals-module"
	],
	"../Accouting/balance-sheet/balance-sheet.module": [
		"./src/app/Accouting/balance-sheet/balance-sheet.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~a09e614a",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~b316c606",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~366bfa2a",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~a3a578ed",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~10521bbc",
		"common",
		"Accouting-balance-sheet-balance-sheet-module"
	],
	"../Accouting/bank-accounts/bank-accounts.module": [
		"./src/app/Accouting/bank-accounts/bank-accounts.module.ts",
		"Accouting-bank-accounts-bank-accounts-module"
	],
	"../Accouting/bank-reconcilation/bank-reconcilation.module": [
		"./src/app/Accouting/bank-reconcilation/bank-reconcilation.module.ts",
		"Accouting-bank-reconcilation-bank-reconcilation-module"
	],
	"../Accouting/chart-of-accounts/chart-of-accounts.module": [
		"./src/app/Accouting/chart-of-accounts/chart-of-accounts.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~b316c606",
		"common",
		"Accouting-chart-of-accounts-chart-of-accounts-module"
	],
	"../Accouting/default-tax-preference/default-tax-preference.module": [
		"./src/app/Accouting/default-tax-preference/default-tax-preference.module.ts",
		"Accouting-default-tax-preference-default-tax-preference-module"
	],
	"../Accouting/general-ledger/general-ledger.module": [
		"./src/app/Accouting/general-ledger/general-ledger.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~a09e614a",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~b316c606",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~366bfa2a",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~a3a578ed",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~10521bbc",
		"common",
		"Accouting-general-ledger-general-ledger-module"
	],
	"../Accouting/invoice-type/invoice-type.module": [
		"./src/app/Accouting/invoice-type/invoice-type.module.ts",
		"Accouting-invoice-type-invoice-type-module"
	],
	"../Accouting/journal-entry/journal-entry.module": [
		"./src/app/Accouting/journal-entry/journal-entry.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~b316c606",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~366bfa2a",
		"common",
		"Accouting-journal-entry-journal-entry-module"
	],
	"../Accouting/ledgers/ledgers.module": [
		"./src/app/Accouting/ledgers/ledgers.module.ts",
		"Accouting-ledgers-ledgers-module"
	],
	"../Accouting/manage-taxes/manage-taxes.module": [
		"./src/app/Accouting/manage-taxes/manage-taxes.module.ts",
		"Accouting-manage-taxes-manage-taxes-module"
	],
	"../Accouting/manage-tds/manage-tds.module": [
		"./src/app/Accouting/manage-tds/manage-tds.module.ts",
		"Accouting-manage-tds-manage-tds-module"
	],
	"../Accouting/new-chart-of-accounts/new-chart-of-accounts.module": [
		"./src/app/Accouting/new-chart-of-accounts/new-chart-of-accounts.module.ts",
		"Accouting-new-chart-of-accounts-new-chart-of-accounts-module"
	],
	"../Accouting/new-journal-entry/new-journal-entry.module": [
		"./src/app/Accouting/new-journal-entry/new-journal-entry.module.ts",
		"Accouting-new-journal-entry-new-journal-entry-module"
	],
	"../Accouting/new-manage-cess/new-manage-cess.module": [
		"./src/app/Accouting/new-manage-cess/new-manage-cess.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Accouting-new-manage-cess-new-manage-cess-module"
	],
	"../Accouting/new-manage-taxes/new-manage-taxes-list.module": [
		"./src/app/Accouting/new-manage-taxes/new-manage-taxes-list.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Accouting-new-manage-taxes-new-manage-taxes-list-module"
	],
	"../Accouting/newmanagetds/new-managetds/new-managetds.module": [
		"./src/app/Accouting/newmanagetds/new-managetds/new-managetds.module.ts",
		"Accouting-newmanagetds-new-managetds-new-managetds-module"
	],
	"../Accouting/opening-balance-new/opening-balance-new.module": [
		"./src/app/Accouting/opening-balance-new/opening-balance-new.module.ts",
		"Accouting-opening-balance-new-opening-balance-new-module"
	],
	"../Accouting/opening-balance/opening-balance.module": [
		"./src/app/Accouting/opening-balance/opening-balance.module.ts",
		"Accouting-opening-balance-opening-balance-module"
	],
	"../Accouting/profitand-loss/profitand-loss.module": [
		"./src/app/Accouting/profitand-loss/profitand-loss.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~a09e614a",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~b316c606",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~366bfa2a",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~a3a578ed",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~10521bbc",
		"common",
		"Accouting-profitand-loss-profitand-loss-module"
	],
	"../Accouting/tax-exemptions/tax-exemptions.module": [
		"./src/app/Accouting/tax-exemptions/tax-exemptions.module.ts",
		"Accouting-tax-exemptions-tax-exemptions-module"
	],
	"../Accouting/trial-balance/trial-balance.module": [
		"./src/app/Accouting/trial-balance/trial-balance.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~a09e614a",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~b316c606",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~366bfa2a",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~a3a578ed",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~10521bbc",
		"common",
		"Accouting-trial-balance-trial-balance-module"
	],
	"../Bookings/Booking/booking.module": [
		"./src/app/Bookings/Booking/booking.module.ts",
		"Bookings-Booking-booking-module"
	],
	"../Bookings/Destination/PendingArrival/PendingArrival.module": [
		"./src/app/Bookings/Destination/PendingArrival/PendingArrival.module.ts",
		"Bookings-Destination-PendingArrival-PendingArrival-module"
	],
	"../Bookings/Destination/booking-completed/booking-completed.module": [
		"./src/app/Bookings/Destination/booking-completed/booking-completed.module.ts",
		"Bookings-Destination-booking-completed-booking-completed-module"
	],
	"../Bookings/Destination/confirm-delivery/confirm-delivery.module": [
		"./src/app/Bookings/Destination/confirm-delivery/confirm-delivery.module.ts",
		"default~Bookings-Destination-confirm-delivery-confirm-delivery-module~starrating-starrating-module",
		"common",
		"Bookings-Destination-confirm-delivery-confirm-delivery-module"
	],
	"../Bookings/Destination/destination-gate-in/destination-gate-in.module": [
		"./src/app/Bookings/Destination/destination-gate-in/destination-gate-in.module.ts",
		"Bookings-Destination-destination-gate-in-destination-gate-in-module"
	],
	"../Bookings/Destination/gate-out/gate-out.module": [
		"./src/app/Bookings/Destination/gate-out/gate-out.module.ts",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"common",
		"Bookings-Destination-gate-out-gate-out-module"
	],
	"../Bookings/Destination/return-trips/return-trips.module": [
		"./src/app/Bookings/Destination/return-trips/return-trips.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"common",
		"Bookings-Destination-return-trips-return-trips-module"
	],
	"../Bookings/Destination/vehicle-unloaded/vehicle-unloaded.module": [
		"./src/app/Bookings/Destination/vehicle-unloaded/vehicle-unloaded.module.ts",
		"Bookings-Destination-vehicle-unloaded-vehicle-unloaded-module"
	],
	"../Bookings/Origin/assigned-vehicle/assigned-vehicle.module": [
		"./src/app/Bookings/Origin/assigned-vehicle/assigned-vehicle.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~8dfd363c",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~df1d8f3a",
		"common",
		"Bookings-Origin-assigned-vehicle-assigned-vehicle-module"
	],
	"../Bookings/Origin/dispatched/dispatched.module": [
		"./src/app/Bookings/Origin/dispatched/dispatched.module.ts",
		"Bookings-Origin-dispatched-dispatched-module"
	],
	"../Bookings/Origin/e-way-bill-ready/e-way-bill-ready.module": [
		"./src/app/Bookings/Origin/e-way-bill-ready/e-way-bill-ready.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~8dfd363c",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~df1d8f3a",
		"common",
		"Bookings-Origin-e-way-bill-ready-e-way-bill-ready-module"
	],
	"../Bookings/Origin/ecPickup/ecPickup.module": [
		"./src/app/Bookings/Origin/ecPickup/ecPickup.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~8dfd363c",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~df1d8f3a",
		"common",
		"Bookings-Origin-ecPickup-ecPickup-module"
	],
	"../Bookings/Origin/gate-in/gate-in.module": [
		"./src/app/Bookings/Origin/gate-in/gate-in.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"common",
		"Bookings-Origin-gate-in-gate-in-module"
	],
	"../Bookings/Origin/ready-to-dispatch/ready-to-dispatch.module": [
		"./src/app/Bookings/Origin/ready-to-dispatch/ready-to-dispatch.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"common",
		"Bookings-Origin-ready-to-dispatch-ready-to-dispatch-module"
	],
	"../Bookings/Origin/vehicle-loaded/vehicle-loaded.module": [
		"./src/app/Bookings/Origin/vehicle-loaded/vehicle-loaded.module.ts",
		"Bookings-Origin-vehicle-loaded-vehicle-loaded-module"
	],
	"../Bookings/TripDocumentPrint/TripDocumentPrint.module": [
		"./src/app/Bookings/TripDocumentPrint/TripDocumentPrint.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~8dfd363c",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~df1d8f3a",
		"default~Bookings-TripDocumentPrint-TripDocumentPrint-module~Reports-Operations-operational-report-dm~fd36d866",
		"common",
		"Bookings-TripDocumentPrint-TripDocumentPrint-module"
	],
	"../Bookings/dashboard/dashboard.module": [
		"./src/app/Bookings/dashboard/dashboard.module.ts",
		"default~Bookings-dashboard-dashboard-module~Quotes-vehicle-planning-new-vehicle-planning-new-module~~bd8ff337",
		"common",
		"Bookings-dashboard-dashboard-module"
	],
	"../Bookings/eway-pdf/eway-pdf.module": [
		"./src/app/Bookings/eway-pdf/eway-pdf.module.ts",
		"default~Bookings-Origin-assigned-vehicle-assigned-vehicle-module~Bookings-Origin-e-way-bill-ready-e-~8dfd363c",
		"common"
	],
	"../Bookings/multiPickup/mp_GateIn/mp_GateIn.module": [
		"./src/app/Bookings/multiPickup/mp_GateIn/mp_GateIn.module.ts",
		"Bookings-multiPickup-mp_GateIn-mp_GateIn-module"
	],
	"../Bookings/multiPickup/mp_OriginGateOut/mp_OriginGateOut.module": [
		"./src/app/Bookings/multiPickup/mp_OriginGateOut/mp_OriginGateOut.module.ts",
		"Bookings-multiPickup-mp_OriginGateOut-mp_OriginGateOut-module"
	],
	"../Bookings/multiPickup/mp_PendingLR/mp_PendingLR.module": [
		"./src/app/Bookings/multiPickup/mp_PendingLR/mp_PendingLR.module.ts",
		"Bookings-multiPickup-mp_PendingLR-mp_PendingLR-module"
	],
	"../EmailConfiguration/EmailConfiguration.module": [
		"./src/app/EmailConfiguration/EmailConfiguration.module.ts",
		"EmailConfiguration-EmailConfiguration-module"
	],
	"../Fleet/NewReminders/new-service-reminder/new-service-reminder.module": [
		"./src/app/Fleet/NewReminders/new-service-reminder/new-service-reminder.module.ts",
		"Fleet-NewReminders-new-service-reminder-new-service-reminder-module"
	],
	"../Fleet/NewReminders/renewal/renewal.module": [
		"./src/app/Fleet/NewReminders/renewal/renewal.module.ts",
		"Fleet-NewReminders-renewal-renewal-module"
	],
	"../Fleet/NewReminders/task-type/task-type.module": [
		"./src/app/Fleet/NewReminders/task-type/task-type.module.ts",
		"Fleet-NewReminders-task-type-task-type-module"
	],
	"../Fleet/NewTyres/NewTyres-discard/newtyres-discard.module": [
		"./src/app/Fleet/NewTyres/NewTyres-discard/newtyres-discard.module.ts",
		"Fleet-NewTyres-NewTyres-discard-newtyres-discard-module"
	],
	"../Fleet/NewTyres/new-tyresassign/new-tyresassign.module": [
		"./src/app/Fleet/NewTyres/new-tyresassign/new-tyresassign.module.ts",
		"Fleet-NewTyres-new-tyresassign-new-tyresassign-module"
	],
	"../Fleet/NewTyres/newtyres-list/newtyres-list.module": [
		"./src/app/Fleet/NewTyres/newtyres-list/newtyres-list.module.ts",
		"Fleet-NewTyres-newtyres-list-newtyres-list-module"
	],
	"../Fleet/NewTyres/newtyres-repair/newtyres-repair.module": [
		"./src/app/Fleet/NewTyres/newtyres-repair/newtyres-repair.module.ts",
		"Fleet-NewTyres-newtyres-repair-newtyres-repair-module"
	],
	"../Fleet/NewTyres/newtyresretreading/newtyresretreading.module": [
		"./src/app/Fleet/NewTyres/newtyresretreading/newtyresretreading.module.ts",
		"Fleet-NewTyres-newtyresretreading-newtyresretreading-module"
	],
	"../Fleet/Tyres/tyres-assign/tyres-assign.module": [
		"./src/app/Fleet/Tyres/tyres-assign/tyres-assign.module.ts",
		"default~Fleet-Tyres-tyres-assign-tyres-assign-module~Fleet-vehicle-master-vehicle-master-module",
		"common",
		"Fleet-Tyres-tyres-assign-tyres-assign-module"
	],
	"../Fleet/Tyres/tyres-discard/tyres-discard.module": [
		"./src/app/Fleet/Tyres/tyres-discard/tyres-discard.module.ts",
		"common",
		"Fleet-Tyres-tyres-discard-tyres-discard-module"
	],
	"../Fleet/Tyres/tyres-list/tyres-list.module": [
		"./src/app/Fleet/Tyres/tyres-list/tyres-list.module.ts",
		"common",
		"Fleet-Tyres-tyres-list-tyres-list-module"
	],
	"../Fleet/Tyres/tyres-reatreading/tyres-reatreading.module": [
		"./src/app/Fleet/Tyres/tyres-reatreading/tyres-reatreading.module.ts",
		"common",
		"Fleet-Tyres-tyres-reatreading-tyres-reatreading-module"
	],
	"../Fleet/Tyres/tyres-repair/tyres-repair.module": [
		"./src/app/Fleet/Tyres/tyres-repair/tyres-repair.module.ts",
		"common",
		"Fleet-Tyres-tyres-repair-tyres-repair-module"
	],
	"../Fleet/driver/driver.module": [
		"./src/app/Fleet/driver/driver.module.ts",
		"Fleet-driver-driver-module"
	],
	"../Fleet/e-challan/e-challan.module": [
		"./src/app/Fleet/e-challan/e-challan.module.ts",
		"Fleet-e-challan-e-challan-module"
	],
	"../Fleet/fastag/fastag.module": [
		"./src/app/Fleet/fastag/fastag.module.ts",
		"Fleet-fastag-fastag-module"
	],
	"../Fleet/issues/issues.module": [
		"./src/app/Fleet/issues/issues.module.ts",
		"Fleet-issues-issues-module"
	],
	"../Fleet/live-vehicle-tracking/live-vehicle-tracking.module": [
		"./src/app/Fleet/live-vehicle-tracking/live-vehicle-tracking.module.ts",
		"Fleet-live-vehicle-tracking-live-vehicle-tracking-module"
	],
	"../Fleet/new-attachment-folders/new-attachment-folders.module": [
		"./src/app/Fleet/new-attachment-folders/new-attachment-folders.module.ts",
		"Fleet-new-attachment-folders-new-attachment-folders-module"
	],
	"../Fleet/new-driver/new-driver.module": [
		"./src/app/Fleet/new-driver/new-driver.module.ts",
		"Fleet-new-driver-new-driver-module"
	],
	"../Fleet/new-repair-maintenance/new-repair-maintenance.module": [
		"./src/app/Fleet/new-repair-maintenance/new-repair-maintenance.module.ts",
		"Fleet-new-repair-maintenance-new-repair-maintenance-module"
	],
	"../Fleet/new-vehicle-inspection/new-vehicle-inspection.module": [
		"./src/app/Fleet/new-vehicle-inspection/new-vehicle-inspection.module.ts",
		"Fleet-new-vehicle-inspection-new-vehicle-inspection-module"
	],
	"../Fleet/new-vehicle-master/vehicle-list.module": [
		"./src/app/Fleet/new-vehicle-master/vehicle-list.module.ts",
		"Fleet-new-vehicle-master-vehicle-list-module"
	],
	"../Fleet/toll-plaza/toll-plaza.module": [
		"./src/app/Fleet/toll-plaza/toll-plaza.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Fleet-toll-plaza-toll-plaza-module"
	],
	"../Fleet/vehicle-inspection/vehicle-inspection.module": [
		"./src/app/Fleet/vehicle-inspection/vehicle-inspection.module.ts",
		"Fleet-vehicle-inspection-vehicle-inspection-module"
	],
	"../Fleet/vehicle-master/vehicle-master.module": [
		"./src/app/Fleet/vehicle-master/vehicle-master.module.ts",
		"default~Fleet-Tyres-tyres-assign-tyres-assign-module~Fleet-vehicle-master-vehicle-master-module",
		"common",
		"Fleet-vehicle-master-vehicle-master-module"
	],
	"../Fleet/vehicle-tracking/vehicle-tracking.module": [
		"./src/app/Fleet/vehicle-tracking/vehicle-tracking.module.ts",
		"Fleet-vehicle-tracking-vehicle-tracking-module"
	],
	"../FuelPump/FuelPump.module": [
		"./src/app/FuelPump/FuelPump.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~a09e614a",
		"common",
		"FuelPump-FuelPump-module"
	],
	"../Masters/CityMaster/CityMaster.module": [
		"./src/app/Masters/CityMaster/CityMaster.module.ts",
		"Masters-CityMaster-CityMaster-module"
	],
	"../Masters/MultiPointLaneConfig/MultiPointLaneConfig.module": [
		"./src/app/Masters/MultiPointLaneConfig/MultiPointLaneConfig.module.ts",
		"Masters-MultiPointLaneConfig-MultiPointLaneConfig-module"
	],
	"../Masters/New-ReasonMaster/new-reasonmaster/new-reasonmaster.module": [
		"./src/app/Masters/New-ReasonMaster/new-reasonmaster/new-reasonmaster.module.ts",
		"Masters-New-ReasonMaster-new-reasonmaster-new-reasonmaster-module"
	],
	"../Masters/Products/new-products/new-products.module": [
		"./src/app/Masters/Products/new-products/new-products.module.ts",
		"Masters-Products-new-products-new-products-module"
	],
	"../Masters/RouteLocationMaster/RouteLocationMaster.module": [
		"./src/app/Masters/RouteLocationMaster/RouteLocationMaster.module.ts",
		"Masters-RouteLocationMaster-RouteLocationMaster-module"
	],
	"../Masters/TimeWindowMaster/TimeWindowMaster.module": [
		"./src/app/Masters/TimeWindowMaster/TimeWindowMaster.module.ts",
		"Masters-TimeWindowMaster-TimeWindowMaster-module"
	],
	"../Masters/allocation_mapping_by_network_type/allocation_mapping_by_network_type.module": [
		"./src/app/Masters/allocation_mapping_by_network_type/allocation_mapping_by_network_type.module.ts",
		"Masters-allocation_mapping_by_network_type-allocation_mapping_by_network_type-module"
	],
	"../Masters/auto-message-configuration/auto-message-configuration.module": [
		"./src/app/Masters/auto-message-configuration/auto-message-configuration.module.ts",
		"Masters-auto-message-configuration-auto-message-configuration-module"
	],
	"../Masters/bin-mapping-by-networktype/bin-mapping-by-networktype.module": [
		"./src/app/Masters/bin-mapping-by-networktype/bin-mapping-by-networktype.module.ts",
		"Masters-bin-mapping-by-networktype-bin-mapping-by-networktype-module"
	],
	"../Masters/bin-mapping-by-product-category/bin-mapping-by-product-category.module": [
		"./src/app/Masters/bin-mapping-by-product-category/bin-mapping-by-product-category.module.ts",
		"Masters-bin-mapping-by-product-category-bin-mapping-by-product-category-module"
	],
	"../Masters/bin-storage-mapping/bin-storage-mapping.module": [
		"./src/app/Masters/bin-storage-mapping/bin-storage-mapping.module.ts",
		"Masters-bin-storage-mapping-bin-storage-mapping-module"
	],
	"../Masters/bosch-business-division/bosch-business-division.module": [
		"./src/app/Masters/bosch-business-division/bosch-business-division.module.ts",
		"Masters-bosch-business-division-bosch-business-division-module"
	],
	"../Masters/bosch-legal-entity-name/bosch-legal-entity-name.module": [
		"./src/app/Masters/bosch-legal-entity-name/bosch-legal-entity-name.module.ts",
		"Masters-bosch-legal-entity-name-bosch-legal-entity-name-module"
	],
	"../Masters/bpcl-setting/bpcl-setting.module": [
		"./src/app/Masters/bpcl-setting/bpcl-setting.module.ts",
		"Masters-bpcl-setting-bpcl-setting-module"
	],
	"../Masters/budget/budget.module": [
		"./src/app/Masters/budget/budget.module.ts",
		"Masters-budget-budget-module"
	],
	"../Masters/business-new/business-new.module": [
		"./src/app/Masters/business-new/business-new.module.ts",
		"Masters-business-new-business-new-module"
	],
	"../Masters/business/business.module": [
		"./src/app/Masters/business/business.module.ts",
		"Masters-business-business-module"
	],
	"../Masters/cargomodes/cargomodes.module": [
		"./src/app/Masters/cargomodes/cargomodes.module.ts",
		"Masters-cargomodes-cargomodes-module"
	],
	"../Masters/carrier/carrier.module": [
		"./src/app/Masters/carrier/carrier.module.ts",
		"Masters-carrier-carrier-module"
	],
	"../Masters/chargemethod/chargemethod.module": [
		"./src/app/Masters/chargemethod/chargemethod.module.ts",
		"Masters-chargemethod-chargemethod-module"
	],
	"../Masters/charges-new/charges-new.module": [
		"./src/app/Masters/charges-new/charges-new.module.ts",
		"Masters-charges-new-charges-new-module"
	],
	"../Masters/charges/charges.module": [
		"./src/app/Masters/charges/charges.module.ts",
		"Masters-charges-charges-module"
	],
	"../Masters/chargetype/chargetype.module": [
		"./src/app/Masters/chargetype/chargetype.module.ts",
		"Masters-chargetype-chargetype-module"
	],
	"../Masters/company/company.module": [
		"./src/app/Masters/company/company.module.ts",
		"Masters-company-company-module"
	],
	"../Masters/country/country.module": [
		"./src/app/Masters/country/country.module.ts",
		"Masters-country-country-module"
	],
	"../Masters/couponMaster/couponMaster.module": [
		"./src/app/Masters/couponMaster/couponMaster.module.ts",
		"Masters-couponMaster-couponMaster-module"
	],
	"../Masters/customer-warehouse-mapping/customerwarehousemapping.module": [
		"./src/app/Masters/customer-warehouse-mapping/customerwarehousemapping.module.ts",
		"Masters-customer-warehouse-mapping-customerwarehousemapping-module"
	],
	"../Masters/declaration-category/declaration-category.module": [
		"./src/app/Masters/declaration-category/declaration-category.module.ts",
		"Masters-declaration-category-declaration-category-module"
	],
	"../Masters/detailed-report/report-detail/report-detail.module": [
		"./src/app/Masters/detailed-report/report-detail/report-detail.module.ts",
		"Masters-detailed-report-report-detail-report-detail-module"
	],
	"../Masters/detailed-report/report-main/report-main.module": [
		"./src/app/Masters/detailed-report/report-main/report-main.module.ts",
		"Masters-detailed-report-report-main-report-main-module"
	],
	"../Masters/detailed-report/report-nav/report-nav.module": [
		"./src/app/Masters/detailed-report/report-nav/report-nav.module.ts",
		"Masters-detailed-report-report-nav-report-nav-module"
	],
	"../Masters/detailed-report/report/report.module": [
		"./src/app/Masters/detailed-report/report/report.module.ts",
		"Masters-detailed-report-report-report-module"
	],
	"../Masters/detailed-report/transaction-details/transaction-details.module": [
		"./src/app/Masters/detailed-report/transaction-details/transaction-details.module.ts",
		"Masters-detailed-report-transaction-details-transaction-details-module"
	],
	"../Masters/dimension-configuration/dimension-configuration.module": [
		"./src/app/Masters/dimension-configuration/dimension-configuration.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-dimension-configuration-dimension-configuration-module"
	],
	"../Masters/ecommerce-configuration/ecommerce-configuration.module": [
		"./src/app/Masters/ecommerce-configuration/ecommerce-configuration.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-ecommerce-configuration-ecommerce-configuration-module"
	],
	"../Masters/email-configuration-new/emailconfigurationnew.module": [
		"./src/app/Masters/email-configuration-new/emailconfigurationnew.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-email-configuration-new-emailconfigurationnew-module"
	],
	"../Masters/fuel/fuel.module": [
		"./src/app/Masters/fuel/fuel.module.ts",
		"Masters-fuel-fuel-module"
	],
	"../Masters/fuelPricePumpWise/fuelPricePumpWise.module": [
		"./src/app/Masters/fuelPricePumpWise/fuelPricePumpWise.module.ts",
		"Masters-fuelPricePumpWise-fuelPricePumpWise-module"
	],
	"../Masters/google-pay/google-pay.module": [
		"./src/app/Masters/google-pay/google-pay.module.ts",
		"Masters-google-pay-google-pay-module"
	],
	"../Masters/item/item.module": [
		"./src/app/Masters/item/item.module.ts",
		"Masters-item-item-module"
	],
	"../Masters/manage-routes/manageroutes.module": [
		"./src/app/Masters/manage-routes/manageroutes.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-manage-routes-manageroutes-module"
	],
	"../Masters/master-rate-contract/masterratecontract.module": [
		"./src/app/Masters/master-rate-contract/masterratecontract.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-master-rate-contract-masterratecontract-module"
	],
	"../Masters/master-rate-template-product/master-rate-template-product.module": [
		"./src/app/Masters/master-rate-template-product/master-rate-template-product.module.ts",
		"Masters-master-rate-template-product-master-rate-template-product-module"
	],
	"../Masters/master-rate-template/master-rate-template.module": [
		"./src/app/Masters/master-rate-template/master-rate-template.module.ts",
		"Masters-master-rate-template-master-rate-template-module"
	],
	"../Masters/message-automation-settings/message-automation-settings.module": [
		"./src/app/Masters/message-automation-settings/message-automation-settings.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-message-automation-settings-message-automation-settings-module"
	],
	"../Masters/new-business-category/new-business-category.module": [
		"./src/app/Masters/new-business-category/new-business-category.module.ts",
		"Masters-new-business-category-new-business-category-module"
	],
	"../Masters/new-city-master/new-city-master.module": [
		"./src/app/Masters/new-city-master/new-city-master.module.ts",
		"common",
		"Masters-new-city-master-new-city-master-module"
	],
	"../Masters/new-company/company-list.module": [
		"./src/app/Masters/new-company/company-list.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-new-company-company-list-module"
	],
	"../Masters/new-configurations/new-configurations.module": [
		"./src/app/Masters/new-configurations/new-configurations.module.ts",
		"common",
		"Masters-new-configurations-new-configurations-module"
	],
	"../Masters/new-coupon-master/new-coupon-master.module": [
		"./src/app/Masters/new-coupon-master/new-coupon-master.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-new-coupon-master-new-coupon-master-module"
	],
	"../Masters/new-pincode/new-pincode.module": [
		"./src/app/Masters/new-pincode/new-pincode.module.ts",
		"common",
		"Masters-new-pincode-new-pincode-module"
	],
	"../Masters/new-settings/new-settings.module": [
		"./src/app/Masters/new-settings/new-settings.module.ts",
		"Masters-new-settings-new-settings-module"
	],
	"../Masters/new-shipmentmode/shipmentmode.module": [
		"./src/app/Masters/new-shipmentmode/shipmentmode.module.ts",
		"Masters-new-shipmentmode-shipmentmode-module"
	],
	"../Masters/new-transportservices/transportservices.module": [
		"./src/app/Masters/new-transportservices/transportservices.module.ts",
		"Masters-new-transportservices-transportservices-module"
	],
	"../Masters/new-user/new-user-list.module": [
		"./src/app/Masters/new-user/new-user-list.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-new-user-new-user-list-module"
	],
	"../Masters/new-vehicletype/new-vehicletype/new-vehicletype.module": [
		"./src/app/Masters/new-vehicletype/new-vehicletype/new-vehicletype.module.ts",
		"Masters-new-vehicletype-new-vehicletype-new-vehicletype-module"
	],
	"../Masters/newFuelPricePumpWise/fuel-pump-wise/fuel-pump-wise.module": [
		"./src/app/Masters/newFuelPricePumpWise/fuel-pump-wise/fuel-pump-wise.module.ts",
		"Masters-newFuelPricePumpWise-fuel-pump-wise-fuel-pump-wise-module"
	],
	"../Masters/newfuel/fuelbycity/fuelbycity.module": [
		"./src/app/Masters/newfuel/fuelbycity/fuelbycity.module.ts",
		"Masters-newfuel-fuelbycity-fuelbycity-module"
	],
	"../Masters/payment-gateway/payment-gateway.module": [
		"./src/app/Masters/payment-gateway/payment-gateway.module.ts",
		"Masters-payment-gateway-payment-gateway-module"
	],
	"../Masters/pincode-mapping/pincode-mapping.module": [
		"./src/app/Masters/pincode-mapping/pincode-mapping.module.ts",
		"Masters-pincode-mapping-pincode-mapping-module"
	],
	"../Masters/product-bin-mapping-pickphase/product-bin-mapping-pickphase.module": [
		"./src/app/Masters/product-bin-mapping-pickphase/product-bin-mapping-pickphase.module.ts",
		"Masters-product-bin-mapping-pickphase-product-bin-mapping-pickphase-module"
	],
	"../Masters/product-rate-contract/productratecontract.module": [
		"./src/app/Masters/product-rate-contract/productratecontract.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Masters-product-rate-contract-productratecontract-module~new-network-new-network-module",
		"common",
		"Masters-product-rate-contract-productratecontract-module"
	],
	"../Masters/reason-master/reason-master.module": [
		"./src/app/Masters/reason-master/reason-master.module.ts",
		"Masters-reason-master-reason-master-module"
	],
	"../Masters/region/region.module": [
		"./src/app/Masters/region/region.module.ts",
		"Masters-region-region-module"
	],
	"../Masters/route-location-masternew/routelocationmasternew.module": [
		"./src/app/Masters/route-location-masternew/routelocationmasternew.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-route-location-masternew-routelocationmasternew-module"
	],
	"../Masters/salesman-route-mapping/salesman-route-mapping.module": [
		"./src/app/Masters/salesman-route-mapping/salesman-route-mapping.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-salesman-route-mapping-salesman-route-mapping-module"
	],
	"../Masters/sector/sector.module": [
		"./src/app/Masters/sector/sector.module.ts",
		"Masters-sector-sector-module"
	],
	"../Masters/service-type/service-type.module": [
		"./src/app/Masters/service-type/service-type.module.ts",
		"Masters-service-type-service-type-module"
	],
	"../Masters/settings/settings.module": [
		"./src/app/Masters/settings/settings.module.ts",
		"common",
		"Masters-settings-settings-module"
	],
	"../Masters/shipmentmode/shipmentmode.module": [
		"./src/app/Masters/shipmentmode/shipmentmode.module.ts",
		"Masters-shipmentmode-shipmentmode-module"
	],
	"../Masters/state/state.module": [
		"./src/app/Masters/state/state.module.ts",
		"common",
		"Masters-state-state-module"
	],
	"../Masters/supplier-tat-configuration/supplier-tat-configuration/supplier-tat-configuration.module": [
		"./src/app/Masters/supplier-tat-configuration/supplier-tat-configuration/supplier-tat-configuration.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Masters-supplier-tat-configuration-supplier-tat-configuration-supplier-tat-configuration-module"
	],
	"../Masters/target-new/target-new.module": [
		"./src/app/Masters/target-new/target-new.module.ts",
		"Masters-target-new-target-new-module"
	],
	"../Masters/transportservices/transportservices.module": [
		"./src/app/Masters/transportservices/transportservices.module.ts",
		"Masters-transportservices-transportservices-module"
	],
	"../Masters/uom-new/uom-new.module": [
		"./src/app/Masters/uom-new/uom-new.module.ts",
		"Masters-uom-new-uom-new-module"
	],
	"../Masters/uom/uom.module": [
		"./src/app/Masters/uom/uom.module.ts",
		"Masters-uom-uom-module"
	],
	"../Masters/uomproduct-master/uomproduct-master.module": [
		"./src/app/Masters/uomproduct-master/uomproduct-master.module.ts",
		"Masters-uomproduct-master-uomproduct-master-module"
	],
	"../Masters/user/user.module": [
		"./src/app/Masters/user/user.module.ts",
		"Masters-user-user-module"
	],
	"../Masters/vehicletype/vehicletype.module": [
		"./src/app/Masters/vehicletype/vehicletype.module.ts",
		"Masters-vehicletype-vehicletype-module"
	],
	"../Network/network/network.module": [
		"./src/app/Network/network/network.module.ts",
		"Network-network-network-module"
	],
	"../New-Bookings/new-bookinglist/new-bookinglist.module": [
		"./src/app/New-Bookings/new-bookinglist/new-bookinglist.module.ts",
		"New-Bookings-new-bookinglist-new-bookinglist-module"
	],
	"../New-Trips/new-trips/new-trips.module": [
		"./src/app/New-Trips/new-trips/new-trips.module.ts",
		"default~New-Trips-new-trips-new-trips-module~full-truck-load-ftl-container-movement-ftl-container-mo~31d88611",
		"common",
		"New-Trips-new-trips-new-trips-module"
	],
	"../NewRegistration/customer-verification/customer-verification.module": [
		"./src/app/NewRegistration/customer-verification/customer-verification.module.ts",
		"NewRegistration-customer-verification-customer-verification-module"
	],
	"../Orders/ByCourier/ByCourier.module": [
		"./src/app/Orders/ByCourier/ByCourier.module.ts",
		"default~Orders-ByCourier-ByCourier-module~Orders-courier-plan-shipment-courier-plan-shipment-module",
		"common",
		"Orders-ByCourier-ByCourier-module"
	],
	"../Orders/by-customer/by-customer.module": [
		"./src/app/Orders/by-customer/by-customer.module.ts",
		"Orders-by-customer-by-customer-module"
	],
	"../Orders/by-load/load.module": [
		"./src/app/Orders/by-load/load.module.ts",
		"Orders-by-load-load-module"
	],
	"../Orders/by-vehicle/by-vehicle.module": [
		"./src/app/Orders/by-vehicle/by-vehicle.module.ts",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module~Products-produc~a1248a43",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module~invoice-numberi~e8b11628",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module",
		"common",
		"Orders-by-vehicle-by-vehicle-module"
	],
	"../Orders/courier-plan-shipment/courier-plan-shipment.module": [
		"./src/app/Orders/courier-plan-shipment/courier-plan-shipment.module.ts",
		"default~Orders-ByCourier-ByCourier-module~Orders-courier-plan-shipment-courier-plan-shipment-module",
		"common"
	],
	"../Orders/new-courier/new-courier.module": [
		"./src/app/Orders/new-courier/new-courier.module.ts",
		"Orders-new-courier-new-courier-module"
	],
	"../Orders/order.module": [
		"./src/app/Orders/order.module.ts",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"common",
		"Orders-order-module"
	],
	"../Orders/pickup-req/pickupreq-entry.module": [
		"./src/app/Orders/pickup-req/pickupreq-entry.module.ts",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module~Products-produc~a1248a43",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module~invoice-numberi~e8b11628",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module",
		"common",
		"Orders-pickup-req-pickupreq-entry-module"
	],
	"../Orders/slotting/slotting.module": [
		"./src/app/Orders/slotting/slotting.module.ts",
		"Orders-slotting-slotting-module"
	],
	"../Orders/truck-load-new/truck-load-new.module": [
		"./src/app/Orders/truck-load-new/truck-load-new.module.ts",
		"Orders-truck-load-new-truck-load-new-module"
	],
	"../Products/product.module": [
		"./src/app/Products/product.module.ts",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module~Products-produc~a1248a43",
		"common",
		"Products-product-module"
	],
	"../Purchase/PaymentMode_Approval/PaymentMode_Approval.module": [
		"./src/app/Purchase/PaymentMode_Approval/PaymentMode_Approval.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"common",
		"Purchase-PaymentMode_Approval-PaymentMode_Approval-module"
	],
	"../Purchase/advance-payment/advance-payment.module": [
		"./src/app/Purchase/advance-payment/advance-payment.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"common",
		"Purchase-advance-payment-advance-payment-module"
	],
	"../Purchase/bills/bills.module": [
		"./src/app/Purchase/bills/bills.module.ts",
		"Purchase-bills-bills-module"
	],
	"../Purchase/cash-expense/cash-expense.module": [
		"./src/app/Purchase/cash-expense/cash-expense.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Purchase-cash-expense-cash-expense-module"
	],
	"../Purchase/expense/expense.module": [
		"./src/app/Purchase/expense/expense.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~a09e614a",
		"common",
		"Purchase-expense-expense-module"
	],
	"../Purchase/new-payment-request/new-payment-request.module": [
		"./src/app/Purchase/new-payment-request/new-payment-request.module.ts",
		"default~Purchase-new-payment-request-new-payment-request-module~Purchase-payment-made-new-payment-ma~c5cf43b2",
		"common",
		"Purchase-new-payment-request-new-payment-request-module"
	],
	"../Purchase/payment-made-new/payment-made-new.module": [
		"./src/app/Purchase/payment-made-new/payment-made-new.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Purchase-new-payment-request-new-payment-request-module~Purchase-payment-made-new-payment-ma~c5cf43b2",
		"common",
		"Purchase-payment-made-new-payment-made-new-module"
	],
	"../Purchase/payment-made/payment-made.module": [
		"./src/app/Purchase/payment-made/payment-made.module.ts",
		"Purchase-payment-made-payment-made-module"
	],
	"../Purchase/payment-request/payment-request.module": [
		"./src/app/Purchase/payment-request/payment-request.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"common",
		"Purchase-payment-request-payment-request-module"
	],
	"../Purchase/pending-bills/pending-bills.module": [
		"./src/app/Purchase/pending-bills/pending-bills.module.ts",
		"Purchase-pending-bills-pending-bills-module"
	],
	"../Purchase/pending-purchase-bill/pending-purchase-bill.module": [
		"./src/app/Purchase/pending-purchase-bill/pending-purchase-bill.module.ts",
		"Purchase-pending-purchase-bill-pending-purchase-bill-module"
	],
	"../Purchase/purchase-bills/purchase-bills.module": [
		"./src/app/Purchase/purchase-bills/purchase-bills.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Purchase-purchase-bills-purchase-bills-module"
	],
	"../Purchase/requisitions/requisitions.module": [
		"./src/app/Purchase/requisitions/requisitions.module.ts",
		"Purchase-requisitions-requisitions-module"
	],
	"../Purchase/schedule-payment/schedule-payment.module": [
		"./src/app/Purchase/schedule-payment/schedule-payment.module.ts",
		"Purchase-schedule-payment-schedule-payment-module"
	],
	"../Quotes/Quote/quote.module": [
		"./src/app/Quotes/Quote/quote.module.ts",
		"Quotes-Quote-quote-module"
	],
	"../Quotes/vehicle-planning-new/vehicle-planning-new.module": [
		"./src/app/Quotes/vehicle-planning-new/vehicle-planning-new.module.ts",
		"default~Bookings-dashboard-dashboard-module~Quotes-vehicle-planning-new-vehicle-planning-new-module~~bd8ff337",
		"common",
		"Quotes-vehicle-planning-new-vehicle-planning-new-module"
	],
	"../Quotes/vehicle-planning/vehicle-planning.module": [
		"./src/app/Quotes/vehicle-planning/vehicle-planning.module.ts",
		"Quotes-vehicle-planning-vehicle-planning-module"
	],
	"../Reminders/renewal/renewal.module": [
		"./src/app/Reminders/renewal/renewal.module.ts",
		"Reminders-renewal-renewal-module"
	],
	"../Reminders/service/service.module": [
		"./src/app/Reminders/service/service.module.ts",
		"Reminders-service-service-module"
	],
	"../Reminders/task-type/task-type.module": [
		"./src/app/Reminders/task-type/task-type.module.ts",
		"Reminders-task-type-task-type-module"
	],
	"../Reports/Accounts/account-report/BankAccount/BankAccount.module": [
		"./src/app/Reports/Accounts/account-report/BankAccount/BankAccount.module.ts",
		"Reports-Accounts-account-report-BankAccount-BankAccount-module"
	],
	"../Reports/Accounts/account-report/CardAccount/CardAccount.module": [
		"./src/app/Reports/Accounts/account-report/CardAccount/CardAccount.module.ts",
		"Reports-Accounts-account-report-CardAccount-CardAccount-module"
	],
	"../Reports/Accounts/account-report/CashAccount/CashAccount.module": [
		"./src/app/Reports/Accounts/account-report/CashAccount/CashAccount.module.ts",
		"Reports-Accounts-account-report-CashAccount-CashAccount-module"
	],
	"../Reports/Accounts/account-report/JobProfiabilityReportOrderWise/JobProfiabilityReportOrderWise.module": [
		"./src/app/Reports/Accounts/account-report/JobProfiabilityReportOrderWise/JobProfiabilityReportOrderWise.module.ts",
		"Reports-Accounts-account-report-JobProfiabilityReportOrderWise-JobProfiabilityReportOrderWise-module"
	],
	"../Reports/Accounts/account-report/MasterHouseCostBreakUp/MasterHouseCostBreakUp.module": [
		"./src/app/Reports/Accounts/account-report/MasterHouseCostBreakUp/MasterHouseCostBreakUp.module.ts",
		"Reports-Accounts-account-report-MasterHouseCostBreakUp-MasterHouseCostBreakUp-module"
	],
	"../Reports/Accounts/account-report/MasterHouseCostBreakUp_byBranch/MasterHouseCostBreakUp_byBranch.module": [
		"./src/app/Reports/Accounts/account-report/MasterHouseCostBreakUp_byBranch/MasterHouseCostBreakUp_byBranch.module.ts",
		"Reports-Accounts-account-report-MasterHouseCostBreakUp_byBranch-MasterHouseCostBreakUp_byBranch-module"
	],
	"../Reports/Accounts/account-report/MasterHouseCostBreakUp_byCustomer/MasterHouseCostBreakUp_byCustomer.module": [
		"./src/app/Reports/Accounts/account-report/MasterHouseCostBreakUp_byCustomer/MasterHouseCostBreakUp_byCustomer.module.ts",
		"Reports-Accounts-account-report-MasterHouseCostBreakUp_byCustomer-MasterHouseCostBreakUp_byCustomer-module"
	],
	"../Reports/Accounts/account-report/MasterHouseCostBreakUp_byTransporter/MasterHouseCostBreakUp_byTransporter.module": [
		"./src/app/Reports/Accounts/account-report/MasterHouseCostBreakUp_byTransporter/MasterHouseCostBreakUp_byTransporter.module.ts",
		"Reports-Accounts-account-report-MasterHouseCostBreakUp_byTransporter-MasterHouseCostBreakUp_byTransporter-module"
	],
	"../Reports/Accounts/account-report/MasterHouseCostBreakUp_byVehicleType/MasterHouseCostBreakUp_byVehicleType.module": [
		"./src/app/Reports/Accounts/account-report/MasterHouseCostBreakUp_byVehicleType/MasterHouseCostBreakUp_byVehicleType.module.ts",
		"Reports-Accounts-account-report-MasterHouseCostBreakUp_byVehicleType-MasterHouseCostBreakUp_byVehicleType-module"
	],
	"../Reports/Accounts/account-report/OrderTripWise_GeneralLedger_Report/OrderTripWise_GeneralLedger_Report.module": [
		"./src/app/Reports/Accounts/account-report/OrderTripWise_GeneralLedger_Report/OrderTripWise_GeneralLedger_Report.module.ts",
		"Reports-Accounts-account-report-OrderTripWise_GeneralLedger_Report-OrderTripWise_GeneralLedger_Report-module"
	],
	"../Reports/Accounts/account-report/Transport_Bill_Reconciliation_Report/Transport_Bill_Reconciliation_Report.module": [
		"./src/app/Reports/Accounts/account-report/Transport_Bill_Reconciliation_Report/Transport_Bill_Reconciliation_Report.module.ts",
		"Reports-Accounts-account-report-Transport_Bill_Reconciliation_Report-Transport_Bill_Reconciliation_Report-module"
	],
	"../Reports/Accounts/account-report/account-report.module": [
		"./src/app/Reports/Accounts/account-report/account-report.module.ts",
		"Reports-Accounts-account-report-account-report-module"
	],
	"../Reports/Accounts/account-report/aging-report/aging-report.module": [
		"./src/app/Reports/Accounts/account-report/aging-report/aging-report.module.ts",
		"default~Reports-Accounts-account-report-aging-report-aging-report-module~Reports-Accounts-account-re~521119f9",
		"common",
		"Reports-Accounts-account-report-aging-report-aging-report-module"
	],
	"../Reports/Accounts/account-report/approval/approval.module": [
		"./src/app/Reports/Accounts/account-report/approval/approval.module.ts",
		"Reports-Accounts-account-report-approval-approval-module"
	],
	"../Reports/Accounts/account-report/branch-report/branch-report.module": [
		"./src/app/Reports/Accounts/account-report/branch-report/branch-report.module.ts",
		"Reports-Accounts-account-report-branch-report-branch-report-module"
	],
	"../Reports/Accounts/account-report/cash-receipt-report/cash-receipt-report.module": [
		"./src/app/Reports/Accounts/account-report/cash-receipt-report/cash-receipt-report.module.ts",
		"Reports-Accounts-account-report-cash-receipt-report-cash-receipt-report-module"
	],
	"../Reports/Accounts/account-report/chargeslist-report/chargeslist-report.module": [
		"./src/app/Reports/Accounts/account-report/chargeslist-report/chargeslist-report.module.ts",
		"Reports-Accounts-account-report-chargeslist-report-chargeslist-report-module"
	],
	"../Reports/Accounts/account-report/chartofaccount-report/chartofaccount-report.module": [
		"./src/app/Reports/Accounts/account-report/chartofaccount-report/chartofaccount-report.module.ts",
		"Reports-Accounts-account-report-chartofaccount-report-chartofaccount-report-module"
	],
	"../Reports/Accounts/account-report/citymaster-report/citymaster-report.module": [
		"./src/app/Reports/Accounts/account-report/citymaster-report/citymaster-report.module.ts",
		"Reports-Accounts-account-report-citymaster-report-citymaster-report-module"
	],
	"../Reports/Accounts/account-report/customermaster-report/customermaster-report.module": [
		"./src/app/Reports/Accounts/account-report/customermaster-report/customermaster-report.module.ts",
		"Reports-Accounts-account-report-customermaster-report-customermaster-report-module"
	],
	"../Reports/Accounts/account-report/dailystatusreport/dailystatusreport.module": [
		"./src/app/Reports/Accounts/account-report/dailystatusreport/dailystatusreport.module.ts",
		"Reports-Accounts-account-report-dailystatusreport-dailystatusreport-module"
	],
	"../Reports/Accounts/account-report/debitor-creditor-statement/debitor-creditor-statement.module": [
		"./src/app/Reports/Accounts/account-report/debitor-creditor-statement/debitor-creditor-statement.module.ts",
		"default~Reports-Accounts-account-report-aging-report-aging-report-module~Reports-Accounts-account-re~521119f9",
		"common",
		"Reports-Accounts-account-report-debitor-creditor-statement-debitor-creditor-statement-module"
	],
	"../Reports/Accounts/account-report/driver-master-report/driver-master-report.module": [
		"./src/app/Reports/Accounts/account-report/driver-master-report/driver-master-report.module.ts",
		"Reports-Accounts-account-report-driver-master-report-driver-master-report-module"
	],
	"../Reports/Accounts/account-report/expense-register/expense-register.module": [
		"./src/app/Reports/Accounts/account-report/expense-register/expense-register.module.ts",
		"Reports-Accounts-account-report-expense-register-expense-register-module"
	],
	"../Reports/Accounts/account-report/gl-account-report/gl-account-report.module": [
		"./src/app/Reports/Accounts/account-report/gl-account-report/gl-account-report.module.ts",
		"Reports-Accounts-account-report-gl-account-report-gl-account-report-module"
	],
	"../Reports/Accounts/account-report/gst-list-report/gst-list-report.module": [
		"./src/app/Reports/Accounts/account-report/gst-list-report/gst-list-report.module.ts",
		"Reports-Accounts-account-report-gst-list-report-gst-list-report-module"
	],
	"../Reports/Accounts/account-report/gst-purchase/gstpurchase.module": [
		"./src/app/Reports/Accounts/account-report/gst-purchase/gstpurchase.module.ts",
		"Reports-Accounts-account-report-gst-purchase-gstpurchase-module"
	],
	"../Reports/Accounts/account-report/gst-register/gstregister.module": [
		"./src/app/Reports/Accounts/account-report/gst-register/gstregister.module.ts",
		"Reports-Accounts-account-report-gst-register-gstregister-module"
	],
	"../Reports/Accounts/account-report/icici-transaction-logs/icici-transaction-logs.module": [
		"./src/app/Reports/Accounts/account-report/icici-transaction-logs/icici-transaction-logs.module.ts",
		"Reports-Accounts-account-report-icici-transaction-logs-icici-transaction-logs-module"
	],
	"../Reports/Accounts/account-report/job-profitability/job-profitability.module": [
		"./src/app/Reports/Accounts/account-report/job-profitability/job-profitability.module.ts",
		"Reports-Accounts-account-report-job-profitability-job-profitability-module"
	],
	"../Reports/Accounts/account-report/mailsent-to-customer-inv/mailsenttocustomerinv.module": [
		"./src/app/Reports/Accounts/account-report/mailsent-to-customer-inv/mailsenttocustomerinv.module.ts",
		"Reports-Accounts-account-report-mailsent-to-customer-inv-mailsenttocustomerinv-module"
	],
	"../Reports/Accounts/account-report/manage-tds-report/manage-tds-report.module": [
		"./src/app/Reports/Accounts/account-report/manage-tds-report/manage-tds-report.module.ts",
		"Reports-Accounts-account-report-manage-tds-report-manage-tds-report-module"
	],
	"../Reports/Accounts/account-report/opening-balance-report/opening-balance-report.module": [
		"./src/app/Reports/Accounts/account-report/opening-balance-report/opening-balance-report.module.ts",
		"Reports-Accounts-account-report-opening-balance-report-opening-balance-report-module"
	],
	"../Reports/Accounts/account-report/orderlist-report/orderlist-report.module": [
		"./src/app/Reports/Accounts/account-report/orderlist-report/orderlist-report.module.ts",
		"Reports-Accounts-account-report-orderlist-report-orderlist-report-module"
	],
	"../Reports/Accounts/account-report/payment-exceptions/payment-exceptions.module": [
		"./src/app/Reports/Accounts/account-report/payment-exceptions/payment-exceptions.module.ts",
		"Reports-Accounts-account-report-payment-exceptions-payment-exceptions-module"
	],
	"../Reports/Accounts/account-report/payment-register/payment-register.module": [
		"./src/app/Reports/Accounts/account-report/payment-register/payment-register.module.ts",
		"Reports-Accounts-account-report-payment-register-payment-register-module"
	],
	"../Reports/Accounts/account-report/pending-trips-for-bills/pending-trips-for-bills.module": [
		"./src/app/Reports/Accounts/account-report/pending-trips-for-bills/pending-trips-for-bills.module.ts",
		"Reports-Accounts-account-report-pending-trips-for-bills-pending-trips-for-bills-module"
	],
	"../Reports/Accounts/account-report/pending-trips-for-invoicing/pending-trips-for-invoicing.module": [
		"./src/app/Reports/Accounts/account-report/pending-trips-for-invoicing/pending-trips-for-invoicing.module.ts",
		"Reports-Accounts-account-report-pending-trips-for-invoicing-pending-trips-for-invoicing-module"
	],
	"../Reports/Accounts/account-report/productlist-report/productlist-report.module": [
		"./src/app/Reports/Accounts/account-report/productlist-report/productlist-report.module.ts",
		"Reports-Accounts-account-report-productlist-report-productlist-report-module"
	],
	"../Reports/Accounts/account-report/purchase-details-register-pivot/purchase-details-register-pivot.module": [
		"./src/app/Reports/Accounts/account-report/purchase-details-register-pivot/purchase-details-register-pivot.module.ts",
		"Reports-Accounts-account-report-purchase-details-register-pivot-purchase-details-register-pivot-module"
	],
	"../Reports/Accounts/account-report/purchase-details-register/purchase-details-register.module": [
		"./src/app/Reports/Accounts/account-report/purchase-details-register/purchase-details-register.module.ts",
		"Reports-Accounts-account-report-purchase-details-register-purchase-details-register-module"
	],
	"../Reports/Accounts/account-report/purchase-register/purchase-register.module": [
		"./src/app/Reports/Accounts/account-report/purchase-register/purchase-register.module.ts",
		"Reports-Accounts-account-report-purchase-register-purchase-register-module"
	],
	"../Reports/Accounts/account-report/receipt-register/receipt-register.module": [
		"./src/app/Reports/Accounts/account-report/receipt-register/receipt-register.module.ts",
		"Reports-Accounts-account-report-receipt-register-receipt-register-module"
	],
	"../Reports/Accounts/account-report/reminder-types-report/reminder-types-report.module": [
		"./src/app/Reports/Accounts/account-report/reminder-types-report/reminder-types-report.module.ts",
		"Reports-Accounts-account-report-reminder-types-report-reminder-types-report-module"
	],
	"../Reports/Accounts/account-report/repaimaintainence-report/repaimaintainence-report.module": [
		"./src/app/Reports/Accounts/account-report/repaimaintainence-report/repaimaintainence-report.module.ts",
		"Reports-Accounts-account-report-repaimaintainence-report-repaimaintainence-report-module"
	],
	"../Reports/Accounts/account-report/sales-detail-register-pivot/sales-detail-register-pivot.module": [
		"./src/app/Reports/Accounts/account-report/sales-detail-register-pivot/sales-detail-register-pivot.module.ts",
		"Reports-Accounts-account-report-sales-detail-register-pivot-sales-detail-register-pivot-module"
	],
	"../Reports/Accounts/account-report/sales-details-register/sales-details-register.module": [
		"./src/app/Reports/Accounts/account-report/sales-details-register/sales-details-register.module.ts",
		"Reports-Accounts-account-report-sales-details-register-sales-details-register-module"
	],
	"../Reports/Accounts/account-report/sales-register-ksh/sales-register-ksh.module": [
		"./src/app/Reports/Accounts/account-report/sales-register-ksh/sales-register-ksh.module.ts",
		"Reports-Accounts-account-report-sales-register-ksh-sales-register-ksh-module"
	],
	"../Reports/Accounts/account-report/sales-register/sales-register.module": [
		"./src/app/Reports/Accounts/account-report/sales-register/sales-register.module.ts",
		"Reports-Accounts-account-report-sales-register-sales-register-module"
	],
	"../Reports/Accounts/account-report/servicereminder-report/servicereminder-report.module": [
		"./src/app/Reports/Accounts/account-report/servicereminder-report/servicereminder-report.module.ts",
		"Reports-Accounts-account-report-servicereminder-report-servicereminder-report-module"
	],
	"../Reports/Accounts/account-report/tax-exemption-report/tax-exemption-report.module": [
		"./src/app/Reports/Accounts/account-report/tax-exemption-report/tax-exemption-report.module.ts",
		"Reports-Accounts-account-report-tax-exemption-report-tax-exemption-report-module"
	],
	"../Reports/Accounts/account-report/tdsRegisterDetail/tdsRegisterDetail.module": [
		"./src/app/Reports/Accounts/account-report/tdsRegisterDetail/tdsRegisterDetail.module.ts",
		"Reports-Accounts-account-report-tdsRegisterDetail-tdsRegisterDetail-module"
	],
	"../Reports/Accounts/account-report/tdsregister/tdsregister.module": [
		"./src/app/Reports/Accounts/account-report/tdsregister/tdsregister.module.ts",
		"Reports-Accounts-account-report-tdsregister-tdsregister-module"
	],
	"../Reports/Accounts/account-report/transport-service-report/transport-service-report.module": [
		"./src/app/Reports/Accounts/account-report/transport-service-report/transport-service-report.module.ts",
		"Reports-Accounts-account-report-transport-service-report-transport-service-report-module"
	],
	"../Reports/Accounts/account-report/transporter-list-report/transporter-list-report.module": [
		"./src/app/Reports/Accounts/account-report/transporter-list-report/transporter-list-report.module.ts",
		"Reports-Accounts-account-report-transporter-list-report-transporter-list-report-module"
	],
	"../Reports/Accounts/account-report/trip-profitability/trip-profitability.module": [
		"./src/app/Reports/Accounts/account-report/trip-profitability/trip-profitability.module.ts",
		"Reports-Accounts-account-report-trip-profitability-trip-profitability-module"
	],
	"../Reports/Accounts/account-report/tyre-retreading-report/tyre-retreading-report.module": [
		"./src/app/Reports/Accounts/account-report/tyre-retreading-report/tyre-retreading-report.module.ts",
		"Reports-Accounts-account-report-tyre-retreading-report-tyre-retreading-report-module"
	],
	"../Reports/Accounts/account-report/tyrelist-report/tyrelist-report.module": [
		"./src/app/Reports/Accounts/account-report/tyrelist-report/tyrelist-report.module.ts",
		"Reports-Accounts-account-report-tyrelist-report-tyrelist-report-module"
	],
	"../Reports/Accounts/account-report/users-list-report/users-list-report.module": [
		"./src/app/Reports/Accounts/account-report/users-list-report/users-list-report.module.ts",
		"Reports-Accounts-account-report-users-list-report-users-list-report-module"
	],
	"../Reports/Accounts/account-report/vehicle-list-report/vehicle-list-report.module": [
		"./src/app/Reports/Accounts/account-report/vehicle-list-report/vehicle-list-report.module.ts",
		"Reports-Accounts-account-report-vehicle-list-report-vehicle-list-report-module"
	],
	"../Reports/Accounts/account-report/vehicle-wise-pl-report/vehicle-wise-pl-report.module": [
		"./src/app/Reports/Accounts/account-report/vehicle-wise-pl-report/vehicle-wise-pl-report.module.ts",
		"Reports-Accounts-account-report-vehicle-wise-pl-report-vehicle-wise-pl-report-module"
	],
	"../Reports/Accounts/account-report/vendor-list-report/vendor-list-report.module": [
		"./src/app/Reports/Accounts/account-report/vendor-list-report/vendor-list-report.module.ts",
		"Reports-Accounts-account-report-vendor-list-report-vendor-list-report-module"
	],
	"../Reports/Accounts/account-report/voucher-list-report/voucher-list-report.module": [
		"./src/app/Reports/Accounts/account-report/voucher-list-report/voucher-list-report.module.ts",
		"Reports-Accounts-account-report-voucher-list-report-voucher-list-report-module"
	],
	"../Reports/FleetReports/fleet-reports/fleet-reports.module": [
		"./src/app/Reports/FleetReports/fleet-reports/fleet-reports.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-FleetReports-fleet-reports-fleet-reports-module"
	],
	"../Reports/FleetReports/fleet-reports/orders-activity/orders-activity.module": [
		"./src/app/Reports/FleetReports/fleet-reports/orders-activity/orders-activity.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-FleetReports-fleet-reports-orders-activity-orders-activity-module"
	],
	"../Reports/Inventory/inventory-report/bin-utilization-report/bin-utilization-report.module": [
		"./src/app/Reports/Inventory/inventory-report/bin-utilization-report/bin-utilization-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-bin-utilization-report-bin-utilization-report-module"
	],
	"../Reports/Inventory/inventory-report/inventory-report.module": [
		"./src/app/Reports/Inventory/inventory-report/inventory-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-inventory-report-module"
	],
	"../Reports/Inventory/inventory-report/inward-receiving-activity-log/inward-receiving-activity-log.module": [
		"./src/app/Reports/Inventory/inventory-report/inward-receiving-activity-log/inward-receiving-activity-log.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-inward-receiving-activity-log-inward-receiving-activity-log-module"
	],
	"../Reports/Inventory/inventory-report/inward-receiving-performance/inward-receiving-performance.module": [
		"./src/app/Reports/Inventory/inventory-report/inward-receiving-performance/inward-receiving-performance.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-inward-receiving-performance-inward-receiving-performance-module"
	],
	"../Reports/Inventory/inventory-report/inward-register/inward-register.module": [
		"./src/app/Reports/Inventory/inventory-report/inward-register/inward-register.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-inward-register-inward-register-module"
	],
	"../Reports/Inventory/inventory-report/inward-summary/inward-summary.module": [
		"./src/app/Reports/Inventory/inventory-report/inward-summary/inward-summary.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-inward-summary-inward-summary-module"
	],
	"../Reports/Inventory/inventory-report/outward-picking-activity-log/outward-picking-activity-log.module": [
		"./src/app/Reports/Inventory/inventory-report/outward-picking-activity-log/outward-picking-activity-log.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-outward-picking-activity-log-outward-picking-activity-log-module"
	],
	"../Reports/Inventory/inventory-report/outward-picking-performance/outward-picking-performance.module": [
		"./src/app/Reports/Inventory/inventory-report/outward-picking-performance/outward-picking-performance.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-outward-picking-performance-outward-picking-performance-module"
	],
	"../Reports/Inventory/inventory-report/outward-summary/outward-summary.module": [
		"./src/app/Reports/Inventory/inventory-report/outward-summary/outward-summary.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-outward-summary-outward-summary-module"
	],
	"../Reports/Inventory/inventory-report/shelf-life-data-by-age-report/shelf-life-data-by-age-report.module": [
		"./src/app/Reports/Inventory/inventory-report/shelf-life-data-by-age-report/shelf-life-data-by-age-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-shelf-life-data-by-age-report-shelf-life-data-by-age-report-module"
	],
	"../Reports/Inventory/inventory-report/shelf-life-data-report/shelf-life-data-report.module": [
		"./src/app/Reports/Inventory/inventory-report/shelf-life-data-report/shelf-life-data-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-shelf-life-data-report-shelf-life-data-report-module"
	],
	"../Reports/Inventory/inventory-report/so_rpt_outwardRegister/so_rpt_outwardRegister.module": [
		"./src/app/Reports/Inventory/inventory-report/so_rpt_outwardRegister/so_rpt_outwardRegister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-so_rpt_outwardRegister-so_rpt_outwardRegister-module"
	],
	"../Reports/Inventory/inventory-report/stock-audit/stock-audit.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-audit/stock-audit.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-audit-stock-audit-module"
	],
	"../Reports/Inventory/inventory-report/stock-details/stock-details.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-details/stock-details.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-details-stock-details-module"
	],
	"../Reports/Inventory/inventory-report/stock-history-by-location/stock-history-by-location.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-history-by-location/stock-history-by-location.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-history-by-location-stock-history-by-location-module"
	],
	"../Reports/Inventory/inventory-report/stock-ledger-report/stock-ledger-report.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-ledger-report/stock-ledger-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-ledger-report-stock-ledger-report-module"
	],
	"../Reports/Inventory/inventory-report/stock-ledger-summary-report/stock-ledger-summary-report.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-ledger-summary-report/stock-ledger-summary-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-ledger-summary-report-stock-ledger-summary-report-module"
	],
	"../Reports/Inventory/inventory-report/stock-management-report/stock-management-report.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-management-report/stock-management-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-management-report-stock-management-report-module"
	],
	"../Reports/Inventory/inventory-report/stock-movemenet/stock-movement.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-movemenet/stock-movement.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-movemenet-stock-movement-module"
	],
	"../Reports/Inventory/inventory-report/stock-report-by-warehouse/stock-report-by-warehouse.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-report-by-warehouse/stock-report-by-warehouse.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-report-by-warehouse-stock-report-by-warehouse-module"
	],
	"../Reports/Inventory/inventory-report/stock-summary/stock-summary.module": [
		"./src/app/Reports/Inventory/inventory-report/stock-summary/stock-summary.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stock-summary-stock-summary-module"
	],
	"../Reports/Inventory/inventory-report/stockTakingReport/stockTakingReport.module": [
		"./src/app/Reports/Inventory/inventory-report/stockTakingReport/stockTakingReport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-stockTakingReport-stockTakingReport-module"
	],
	"../Reports/Inventory/inventory-report/vehicle-check-list/vehicle-check-list.module": [
		"./src/app/Reports/Inventory/inventory-report/vehicle-check-list/vehicle-check-list.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-Inventory-inventory-report-vehicle-check-list-vehicle-check-list-module"
	],
	"../Reports/NewAccounts/new-accounts/all-reports/allreports.module": [
		"./src/app/Reports/NewAccounts/new-accounts/all-reports/allreports.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-all-reports-allreports-module"
	],
	"../Reports/NewAccounts/new-accounts/bank-account-rp/bankaccountrp.module": [
		"./src/app/Reports/NewAccounts/new-accounts/bank-account-rp/bankaccountrp.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-bank-account-rp-bankaccountrp-module"
	],
	"../Reports/NewAccounts/new-accounts/card-account-rp/cardaccountrp.module": [
		"./src/app/Reports/NewAccounts/new-accounts/card-account-rp/cardaccountrp.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-card-account-rp-cardaccountrp-module"
	],
	"../Reports/NewAccounts/new-accounts/cash-account-rp/cashaccountrp.module": [
		"./src/app/Reports/NewAccounts/new-accounts/cash-account-rp/cashaccountrp.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-cash-account-rp-cashaccountrp-module"
	],
	"../Reports/NewAccounts/new-accounts/cash-receipt-report/cashreceiptreport.module": [
		"./src/app/Reports/NewAccounts/new-accounts/cash-receipt-report/cashreceiptreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-cash-receipt-report-cashreceiptreport-module"
	],
	"../Reports/NewAccounts/new-accounts/debitors-creditors/debitorscreditors.module": [
		"./src/app/Reports/NewAccounts/new-accounts/debitors-creditors/debitorscreditors.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Reports-NewAccounts-new-accounts-debitors-creditors-debitorscreditors-module~Reports-NewAcco~27322490",
		"common",
		"Reports-NewAccounts-new-accounts-debitors-creditors-debitorscreditors-module"
	],
	"../Reports/NewAccounts/new-accounts/expense-register-report/expenseregisterreport.module": [
		"./src/app/Reports/NewAccounts/new-accounts/expense-register-report/expenseregisterreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-expense-register-report-expenseregisterreport-module"
	],
	"../Reports/NewAccounts/new-accounts/general-ledger-rp/generalledgerrp.module": [
		"./src/app/Reports/NewAccounts/new-accounts/general-ledger-rp/generalledgerrp.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-general-ledger-rp-generalledgerrp-module"
	],
	"../Reports/NewAccounts/new-accounts/glaaccount-rp/glaaccountrp.module": [
		"./src/app/Reports/NewAccounts/new-accounts/glaaccount-rp/glaaccountrp.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-glaaccount-rp-glaaccountrp-module"
	],
	"../Reports/NewAccounts/new-accounts/gst-purchase/gstpurchase.module": [
		"./src/app/Reports/NewAccounts/new-accounts/gst-purchase/gstpurchase.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-gst-purchase-gstpurchase-module"
	],
	"../Reports/NewAccounts/new-accounts/gst-sales/gstsales.module": [
		"./src/app/Reports/NewAccounts/new-accounts/gst-sales/gstsales.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-gst-sales-gstsales-module"
	],
	"../Reports/NewAccounts/new-accounts/newaccounts.module": [
		"./src/app/Reports/NewAccounts/new-accounts/newaccounts.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Reports-NewAccounts-new-accounts-newaccounts-module~Reports-NewAccounts-new-accounts-report-~37b773a3",
		"common",
		"Reports-NewAccounts-new-accounts-newaccounts-module"
	],
	"../Reports/NewAccounts/new-accounts/payable-aging-report/payableagingreport.module": [
		"./src/app/Reports/NewAccounts/new-accounts/payable-aging-report/payableagingreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-payable-aging-report-payableagingreport-module"
	],
	"../Reports/NewAccounts/new-accounts/payment-register-report/paymentregisterreport.module": [
		"./src/app/Reports/NewAccounts/new-accounts/payment-register-report/paymentregisterreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-payment-register-report-paymentregisterreport-module"
	],
	"../Reports/NewAccounts/new-accounts/pending-trip-for-bill/pendingtripforbill.module": [
		"./src/app/Reports/NewAccounts/new-accounts/pending-trip-for-bill/pendingtripforbill.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-pending-trip-for-bill-pendingtripforbill-module"
	],
	"../Reports/NewAccounts/new-accounts/pending-trip-for-invoice/pendingtripforinvoice.module": [
		"./src/app/Reports/NewAccounts/new-accounts/pending-trip-for-invoice/pendingtripforinvoice.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-pending-trip-for-invoice-pendingtripforinvoice-module"
	],
	"../Reports/NewAccounts/new-accounts/purchase-detail-register/purchasedetailregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/purchase-detail-register/purchasedetailregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-purchase-detail-register-purchasedetailregister-module"
	],
	"../Reports/NewAccounts/new-accounts/purchase-register/purchaseregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/purchase-register/purchaseregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-purchase-register-purchaseregister-module"
	],
	"../Reports/NewAccounts/new-accounts/receipt-register/receiptregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/receipt-register/receiptregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-receipt-register-receiptregister-module"
	],
	"../Reports/NewAccounts/new-accounts/receivable-aging-report/receivableagingreport.module": [
		"./src/app/Reports/NewAccounts/new-accounts/receivable-aging-report/receivableagingreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Reports-NewAccounts-new-accounts-debitors-creditors-debitorscreditors-module~Reports-NewAcco~27322490",
		"common",
		"Reports-NewAccounts-new-accounts-receivable-aging-report-receivableagingreport-module"
	],
	"../Reports/NewAccounts/new-accounts/report-details/reportdetails.module": [
		"./src/app/Reports/NewAccounts/new-accounts/report-details/reportdetails.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-report-details-reportdetails-module"
	],
	"../Reports/NewAccounts/new-accounts/report-main/reportmain.module": [
		"./src/app/Reports/NewAccounts/new-accounts/report-main/reportmain.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-report-main-reportmain-module"
	],
	"../Reports/NewAccounts/new-accounts/report-menu/reportmenu.module": [
		"./src/app/Reports/NewAccounts/new-accounts/report-menu/reportmenu.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Reports-NewAccounts-new-accounts-newaccounts-module~Reports-NewAccounts-new-accounts-report-~37b773a3",
		"common",
		"Reports-NewAccounts-new-accounts-report-menu-reportmenu-module"
	],
	"../Reports/NewAccounts/new-accounts/sales-detail-register-pivot/salesdetailregisterpivot.module": [
		"./src/app/Reports/NewAccounts/new-accounts/sales-detail-register-pivot/salesdetailregisterpivot.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-sales-detail-register-pivot-salesdetailregisterpivot-module"
	],
	"../Reports/NewAccounts/new-accounts/sales-detail-register/salesdetailregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/sales-detail-register/salesdetailregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-sales-detail-register-salesdetailregister-module"
	],
	"../Reports/NewAccounts/new-accounts/sales-register-multipoint/salesregistermultipoint.module": [
		"./src/app/Reports/NewAccounts/new-accounts/sales-register-multipoint/salesregistermultipoint.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-sales-register-multipoint-salesregistermultipoint-module"
	],
	"../Reports/NewAccounts/new-accounts/sales-register-orderwise/sales-register-orderwise.module": [
		"./src/app/Reports/NewAccounts/new-accounts/sales-register-orderwise/sales-register-orderwise.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-sales-register-orderwise-sales-register-orderwise-module"
	],
	"../Reports/NewAccounts/new-accounts/sales-register/salesregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/sales-register/salesregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-sales-register-salesregister-module"
	],
	"../Reports/NewAccounts/new-accounts/sales-registerdetail-orderwise/sales-registerdetail-orderwise.module": [
		"./src/app/Reports/NewAccounts/new-accounts/sales-registerdetail-orderwise/sales-registerdetail-orderwise.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-sales-registerdetail-orderwise-sales-registerdetail-orderwise-module"
	],
	"../Reports/NewAccounts/new-accounts/sales-returns-register/salesreturnsregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/sales-returns-register/salesreturnsregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-sales-returns-register-salesreturnsregister-module"
	],
	"../Reports/NewAccounts/new-accounts/tally-transfer-log/tally-transfer-log.module": [
		"./src/app/Reports/NewAccounts/new-accounts/tally-transfer-log/tally-transfer-log.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-tally-transfer-log-tally-transfer-log-module"
	],
	"../Reports/NewAccounts/new-accounts/tds-deduction-register-detail/tdsdeductionregisterdetail.module": [
		"./src/app/Reports/NewAccounts/new-accounts/tds-deduction-register-detail/tdsdeductionregisterdetail.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-tds-deduction-register-detail-tdsdeductionregisterdetail-module"
	],
	"../Reports/NewAccounts/new-accounts/tds-deduction-register/tdsdeductionregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/tds-deduction-register/tdsdeductionregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-tds-deduction-register-tdsdeductionregister-module"
	],
	"../Reports/NewAccounts/new-accounts/tds-register/tdsregister.module": [
		"./src/app/Reports/NewAccounts/new-accounts/tds-register/tdsregister.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-tds-register-tdsregister-module"
	],
	"../Reports/NewAccounts/new-accounts/transaction-details/transactiondetails.module": [
		"./src/app/Reports/NewAccounts/new-accounts/transaction-details/transactiondetails.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewAccounts-new-accounts-transaction-details-transactiondetails-module"
	],
	"../Reports/NewMasters/new-masters/accounts-activity/accountsactivity.module": [
		"./src/app/Reports/NewMasters/new-masters/accounts-activity/accountsactivity.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-accounts-activity-accountsactivity-module"
	],
	"../Reports/NewMasters/new-masters/branch-master/branchmaster.module": [
		"./src/app/Reports/NewMasters/new-masters/branch-master/branchmaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-branch-master-branchmaster-module"
	],
	"../Reports/NewMasters/new-masters/category-master/categorymaster.module": [
		"./src/app/Reports/NewMasters/new-masters/category-master/categorymaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-category-master-categorymaster-module"
	],
	"../Reports/NewMasters/new-masters/charge-list-master/chargelistmaster.module": [
		"./src/app/Reports/NewMasters/new-masters/charge-list-master/chargelistmaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-charge-list-master-chargelistmaster-module"
	],
	"../Reports/NewMasters/new-masters/coamaster/coamaster.module": [
		"./src/app/Reports/NewMasters/new-masters/coamaster/coamaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-coamaster-coamaster-module"
	],
	"../Reports/NewMasters/new-masters/customer-master/customermaster.module": [
		"./src/app/Reports/NewMasters/new-masters/customer-master/customermaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-customer-master-customermaster-module"
	],
	"../Reports/NewMasters/new-masters/customer-rates/customerrates.module": [
		"./src/app/Reports/NewMasters/new-masters/customer-rates/customerrates.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-customer-rates-customerrates-module"
	],
	"../Reports/NewMasters/new-masters/daily-trips/dailytrips.module": [
		"./src/app/Reports/NewMasters/new-masters/daily-trips/dailytrips.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-daily-trips-dailytrips-module"
	],
	"../Reports/NewMasters/new-masters/ewaybill-list/ewaybilllist.module": [
		"./src/app/Reports/NewMasters/new-masters/ewaybill-list/ewaybilllist.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-ewaybill-list-ewaybilllist-module"
	],
	"../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module": [
		"./src/app/Reports/NewMasters/new-masters/exempt-master/exemptmaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-exempt-master-exemptmaster-module"
	],
	"../Reports/NewMasters/new-masters/master-activity/master-activity.module": [
		"./src/app/Reports/NewMasters/new-masters/master-activity/master-activity.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-master-activity-master-activity-module"
	],
	"../Reports/NewMasters/new-masters/new-user-hierarchy/new-user-hierarchy.module": [
		"./src/app/Reports/NewMasters/new-masters/new-user-hierarchy/new-user-hierarchy.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-new-user-hierarchy-new-user-hierarchy-module"
	],
	"../Reports/NewMasters/new-masters/newmasters.module": [
		"./src/app/Reports/NewMasters/new-masters/newmasters.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-newmasters-module"
	],
	"../Reports/NewMasters/new-masters/opening-balance-master/opening-balance-master.module": [
		"./src/app/Reports/NewMasters/new-masters/opening-balance-master/opening-balance-master.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-opening-balance-master-opening-balance-master-module"
	],
	"../Reports/NewMasters/new-masters/operation-activity/operationactivity.module": [
		"./src/app/Reports/NewMasters/new-masters/operation-activity/operationactivity.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-operation-activity-operationactivity-module"
	],
	"../Reports/NewMasters/new-masters/product-master/productmaster.module": [
		"./src/app/Reports/NewMasters/new-masters/product-master/productmaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-product-master-productmaster-module"
	],
	"../Reports/NewMasters/new-masters/sales-targets/salestargets.module": [
		"./src/app/Reports/NewMasters/new-masters/sales-targets/salestargets.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-sales-targets-salestargets-module"
	],
	"../Reports/NewMasters/new-masters/supplier-rates/supplierrates.module": [
		"./src/app/Reports/NewMasters/new-masters/supplier-rates/supplierrates.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-supplier-rates-supplierrates-module"
	],
	"../Reports/NewMasters/new-masters/tax-master/taxmaster.module": [
		"./src/app/Reports/NewMasters/new-masters/tax-master/taxmaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-tax-master-taxmaster-module"
	],
	"../Reports/NewMasters/new-masters/tdsmaster/tdsmaster.module": [
		"./src/app/Reports/NewMasters/new-masters/tdsmaster/tdsmaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-tdsmaster-tdsmaster-module"
	],
	"../Reports/NewMasters/new-masters/transporter-master/Transportermaster.module": [
		"./src/app/Reports/NewMasters/new-masters/transporter-master/Transportermaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-transporter-master-Transportermaster-module"
	],
	"../Reports/NewMasters/new-masters/trip-list/triplist.module": [
		"./src/app/Reports/NewMasters/new-masters/trip-list/triplist.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-trip-list-triplist-module"
	],
	"../Reports/NewMasters/new-masters/vendor-master/vendormaster.module": [
		"./src/app/Reports/NewMasters/new-masters/vendor-master/vendormaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-vendor-master-vendormaster-module"
	],
	"../Reports/NewMasters/new-masters/warehouse-master/warehousemaster.module": [
		"./src/app/Reports/NewMasters/new-masters/warehouse-master/warehousemaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewMasters-new-masters-warehouse-master-warehousemaster-module"
	],
	"../Reports/NewOperations/newoperational-report/apmcreport/apmcreport.module": [
		"./src/app/Reports/NewOperations/newoperational-report/apmcreport/apmcreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-apmcreport-apmcreport-module"
	],
	"../Reports/NewOperations/newoperational-report/auto_allocation_on_ff_log/auto_allocation_on_ff_log.module": [
		"./src/app/Reports/NewOperations/newoperational-report/auto_allocation_on_ff_log/auto_allocation_on_ff_log.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-auto_allocation_on_ff_log-auto_allocation_on_ff_log-module"
	],
	"../Reports/NewOperations/newoperational-report/claim-report/claim-report.module": [
		"./src/app/Reports/NewOperations/newoperational-report/claim-report/claim-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-claim-report-claim-report-module"
	],
	"../Reports/NewOperations/newoperational-report/newoperational-report.module": [
		"./src/app/Reports/NewOperations/newoperational-report/newoperational-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-newoperational-report-module"
	],
	"../Reports/NewOperations/newoperational-report/outward-profit-and-loss-rp/outwardprofitandloss.module": [
		"./src/app/Reports/NewOperations/newoperational-report/outward-profit-and-loss-rp/outwardprofitandloss.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-outward-profit-and-loss-rp-outwardprofitandloss-module"
	],
	"../Reports/NewOperations/newoperational-report/purchase-return-order/purchasereturnorder.module": [
		"./src/app/Reports/NewOperations/newoperational-report/purchase-return-order/purchasereturnorder.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-purchase-return-order-purchasereturnorder-module"
	],
	"../Reports/NewOperations/newoperational-report/purchaseorder-rp/purchaseorderRP.module": [
		"./src/app/Reports/NewOperations/newoperational-report/purchaseorder-rp/purchaseorderRP.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-purchaseorder-rp-purchaseorderRP-module"
	],
	"../Reports/NewOperations/newoperational-report/purchaseorderrpdetail/purchaseorderdetail.module": [
		"./src/app/Reports/NewOperations/newoperational-report/purchaseorderrpdetail/purchaseorderdetail.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-purchaseorderrpdetail-purchaseorderdetail-module"
	],
	"../Reports/NewOperations/newoperational-report/sales-order-wave-report/sales-order-wave-report.module": [
		"./src/app/Reports/NewOperations/newoperational-report/sales-order-wave-report/sales-order-wave-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-sales-order-wave-report-sales-order-wave-report-module"
	],
	"../Reports/NewOperations/newoperational-report/sales-return-order/salesreturnorder.module": [
		"./src/app/Reports/NewOperations/newoperational-report/sales-return-order/salesreturnorder.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-sales-return-order-salesreturnorder-module"
	],
	"../Reports/NewOperations/newoperational-report/salesorder-rp/salesorder-rp.module": [
		"./src/app/Reports/NewOperations/newoperational-report/salesorder-rp/salesorder-rp.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-salesorder-rp-salesorder-rp-module"
	],
	"../Reports/NewOperations/newoperational-report/salesorderdetail-rp/salesorderdetail-rp.module": [
		"./src/app/Reports/NewOperations/newoperational-report/salesorderdetail-rp/salesorderdetail-rp.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-salesorderdetail-rp-salesorderdetail-rp-module"
	],
	"../Reports/NewOperations/newoperational-report/so-inward-fullfillment/so-inward-fullfillment.module": [
		"./src/app/Reports/NewOperations/newoperational-report/so-inward-fullfillment/so-inward-fullfillment.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-so-inward-fullfillment-so-inward-fullfillment-module"
	],
	"../Reports/NewOperations/newoperational-report/so-kit-vs-dispatch/so-kit-vs-dispatch.module": [
		"./src/app/Reports/NewOperations/newoperational-report/so-kit-vs-dispatch/so-kit-vs-dispatch.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-so-kit-vs-dispatch-so-kit-vs-dispatch-module"
	],
	"../Reports/NewOperations/newoperational-report/so-sofullfillment-report/so-sofullfillment-report.module": [
		"./src/app/Reports/NewOperations/newoperational-report/so-sofullfillment-report/so-sofullfillment-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-so-sofullfillment-report-so-sofullfillment-report-module"
	],
	"../Reports/NewOperations/newoperational-report/so_POFullfillment_report/so_POFullfillment_report.module": [
		"./src/app/Reports/NewOperations/newoperational-report/so_POFullfillment_report/so_POFullfillment_report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-so_POFullfillment_report-so_POFullfillment_report-module"
	],
	"../Reports/NewOperations/newoperational-report/unconfirm-orderlog-report/unconfirm-orderlog-report.module": [
		"./src/app/Reports/NewOperations/newoperational-report/unconfirm-orderlog-report/unconfirm-orderlog-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-NewOperations-newoperational-report-unconfirm-orderlog-report-unconfirm-orderlog-report-module"
	],
	"../Reports/Operations/operational-report/ExportDispatchReport/ExportDispatchReport.module": [
		"./src/app/Reports/Operations/operational-report/ExportDispatchReport/ExportDispatchReport.module.ts",
		"Reports-Operations-operational-report-ExportDispatchReport-ExportDispatchReport-module"
	],
	"../Reports/Operations/operational-report/ExportJobComplitionReport/ExportJobComplitionReport.module": [
		"./src/app/Reports/Operations/operational-report/ExportJobComplitionReport/ExportJobComplitionReport.module.ts",
		"Reports-Operations-operational-report-ExportJobComplitionReport-ExportJobComplitionReport-module"
	],
	"../Reports/Operations/operational-report/ImportDispathReport/ImportDispathReport.module": [
		"./src/app/Reports/Operations/operational-report/ImportDispathReport/ImportDispathReport.module.ts",
		"Reports-Operations-operational-report-ImportDispathReport-ImportDispathReport-module"
	],
	"../Reports/Operations/operational-report/ImportJobCompletionReport/ImportJobCompletionReport.module": [
		"./src/app/Reports/Operations/operational-report/ImportJobCompletionReport/ImportJobCompletionReport.module.ts",
		"Reports-Operations-operational-report-ImportJobCompletionReport-ImportJobCompletionReport-module"
	],
	"../Reports/Operations/operational-report/LocationWiseBoxesHandled/LocationWiseBoxesHandled.module": [
		"./src/app/Reports/Operations/operational-report/LocationWiseBoxesHandled/LocationWiseBoxesHandled.module.ts",
		"Reports-Operations-operational-report-LocationWiseBoxesHandled-LocationWiseBoxesHandled-module"
	],
	"../Reports/Operations/operational-report/LocationWiseDeliveryPoints/LocationWiseDeliveryPoints.module": [
		"./src/app/Reports/Operations/operational-report/LocationWiseDeliveryPoints/LocationWiseDeliveryPoints.module.ts",
		"Reports-Operations-operational-report-LocationWiseDeliveryPoints-LocationWiseDeliveryPoints-module"
	],
	"../Reports/Operations/operational-report/LocationWiseInvoicesmade/LocationWiseInvoicesmade.module": [
		"./src/app/Reports/Operations/operational-report/LocationWiseInvoicesmade/LocationWiseInvoicesmade.module.ts",
		"Reports-Operations-operational-report-LocationWiseInvoicesmade-LocationWiseInvoicesmade-module"
	],
	"../Reports/Operations/operational-report/LocationWiseKMCovered/LocationWiseKMCovered.module": [
		"./src/app/Reports/Operations/operational-report/LocationWiseKMCovered/LocationWiseKMCovered.module.ts",
		"Reports-Operations-operational-report-LocationWiseKMCovered-LocationWiseKMCovered-module"
	],
	"../Reports/Operations/operational-report/LocationWiseShipToParties/LocationWiseShipToParties.module": [
		"./src/app/Reports/Operations/operational-report/LocationWiseShipToParties/LocationWiseShipToParties.module.ts",
		"Reports-Operations-operational-report-LocationWiseShipToParties-LocationWiseShipToParties-module"
	],
	"../Reports/Operations/operational-report/LocationWiseTransporters/LocationWiseTransporters.module": [
		"./src/app/Reports/Operations/operational-report/LocationWiseTransporters/LocationWiseTransporters.module.ts",
		"Reports-Operations-operational-report-LocationWiseTransporters-LocationWiseTransporters-module"
	],
	"../Reports/Operations/operational-report/LocationWiseVehiclesUsed/LocationWiseVehiclesUsed.module": [
		"./src/app/Reports/Operations/operational-report/LocationWiseVehiclesUsed/LocationWiseVehiclesUsed.module.ts",
		"Reports-Operations-operational-report-LocationWiseVehiclesUsed-LocationWiseVehiclesUsed-module"
	],
	"../Reports/Operations/operational-report/Order_ConsgnmentTrackingStatusReport/Order_ConsgnmentTrackingStatusReport.module": [
		"./src/app/Reports/Operations/operational-report/Order_ConsgnmentTrackingStatusReport/Order_ConsgnmentTrackingStatusReport.module.ts",
		"Reports-Operations-operational-report-Order_ConsgnmentTrackingStatusReport-Order_ConsgnmentTrackingStatusReport-module"
	],
	"../Reports/Operations/operational-report/SimTrackingReport/SimTrackingReport.module": [
		"./src/app/Reports/Operations/operational-report/SimTrackingReport/SimTrackingReport.module.ts",
		"Reports-Operations-operational-report-SimTrackingReport-SimTrackingReport-module"
	],
	"../Reports/Operations/operational-report/Trip_IncomeExpenseWithPaymentReport/Trip_IncomeExpenseWithPaymentReport.module": [
		"./src/app/Reports/Operations/operational-report/Trip_IncomeExpenseWithPaymentReport/Trip_IncomeExpenseWithPaymentReport.module.ts",
		"Reports-Operations-operational-report-Trip_IncomeExpenseWithPaymentReport-Trip_IncomeExpenseWithPaymentReport-module"
	],
	"../Reports/Operations/operational-report/VehicleSummery/VehicleSummery.module": [
		"./src/app/Reports/Operations/operational-report/VehicleSummery/VehicleSummery.module.ts",
		"Reports-Operations-operational-report-VehicleSummery-VehicleSummery-module"
	],
	"../Reports/Operations/operational-report/activitylog/activitylog.module": [
		"./src/app/Reports/Operations/operational-report/activitylog/activitylog.module.ts",
		"Reports-Operations-operational-report-activitylog-activitylog-module"
	],
	"../Reports/Operations/operational-report/activitylogaccounts/activitylogaccounts.module": [
		"./src/app/Reports/Operations/operational-report/activitylogaccounts/activitylogaccounts.module.ts",
		"Reports-Operations-operational-report-activitylogaccounts-activitylogaccounts-module"
	],
	"../Reports/Operations/operational-report/activitylogmasters/activitylogmasters.module": [
		"./src/app/Reports/Operations/operational-report/activitylogmasters/activitylogmasters.module.ts",
		"Reports-Operations-operational-report-activitylogmasters-activitylogmasters-module"
	],
	"../Reports/Operations/operational-report/advance-payment-request-for-trips/advance-payment-request-for-trips.module": [
		"./src/app/Reports/Operations/operational-report/advance-payment-request-for-trips/advance-payment-request-for-trips.module.ts",
		"Reports-Operations-operational-report-advance-payment-request-for-trips-advance-payment-request-for-trips-module"
	],
	"../Reports/Operations/operational-report/allocated-driver-idle-time/allocated-driver-idle-time.module": [
		"./src/app/Reports/Operations/operational-report/allocated-driver-idle-time/allocated-driver-idle-time.module.ts",
		"Reports-Operations-operational-report-allocated-driver-idle-time-allocated-driver-idle-time-module"
	],
	"../Reports/Operations/operational-report/bidding-rp/bidding-rp.module": [
		"./src/app/Reports/Operations/operational-report/bidding-rp/bidding-rp.module.ts",
		"Reports-Operations-operational-report-bidding-rp-bidding-rp-module"
	],
	"../Reports/Operations/operational-report/bpcl-log/bpcl-log.module": [
		"./src/app/Reports/Operations/operational-report/bpcl-log/bpcl-log.module.ts",
		"Reports-Operations-operational-report-bpcl-log-bpcl-log-module"
	],
	"../Reports/Operations/operational-report/budget-report/budget-report.module": [
		"./src/app/Reports/Operations/operational-report/budget-report/budget-report.module.ts",
		"Reports-Operations-operational-report-budget-report-budget-report-module"
	],
	"../Reports/Operations/operational-report/cashBook/cashBook.module": [
		"./src/app/Reports/Operations/operational-report/cashBook/cashBook.module.ts",
		"Reports-Operations-operational-report-cashBook-cashBook-module"
	],
	"../Reports/Operations/operational-report/consent-report/consentreport.module": [
		"./src/app/Reports/Operations/operational-report/consent-report/consentreport.module.ts",
		"Reports-Operations-operational-report-consent-report-consentreport-module"
	],
	"../Reports/Operations/operational-report/customer-balancebytrip/customerbalancebytrip.module": [
		"./src/app/Reports/Operations/operational-report/customer-balancebytrip/customerbalancebytrip.module.ts",
		"Reports-Operations-operational-report-customer-balancebytrip-customerbalancebytrip-module"
	],
	"../Reports/Operations/operational-report/customer-ratecheck-history/customer-ratecheck-history.module": [
		"./src/app/Reports/Operations/operational-report/customer-ratecheck-history/customer-ratecheck-history.module.ts",
		"Reports-Operations-operational-report-customer-ratecheck-history-customer-ratecheck-history-module"
	],
	"../Reports/Operations/operational-report/customerbalance/customerbalance.module": [
		"./src/app/Reports/Operations/operational-report/customerbalance/customerbalance.module.ts",
		"Reports-Operations-operational-report-customerbalance-customerbalance-module"
	],
	"../Reports/Operations/operational-report/daily-operational-report-detail/daily-operational-report-detail.module": [
		"./src/app/Reports/Operations/operational-report/daily-operational-report-detail/daily-operational-report-detail.module.ts",
		"Reports-Operations-operational-report-daily-operational-report-detail-daily-operational-report-detail-module"
	],
	"../Reports/Operations/operational-report/daily-operational-report/daily-operational-report.module": [
		"./src/app/Reports/Operations/operational-report/daily-operational-report/daily-operational-report.module.ts",
		"Reports-Operations-operational-report-daily-operational-report-daily-operational-report-module"
	],
	"../Reports/Operations/operational-report/daily-order-by-customer-type-of-services-report/daily-order-by-customer-type-of-services-report.module": [
		"./src/app/Reports/Operations/operational-report/daily-order-by-customer-type-of-services-report/daily-order-by-customer-type-of-services-report.module.ts",
		"Reports-Operations-operational-report-daily-order-by-customer-type-of-services-report-daily-order-by-customer-type-of-services-report-module"
	],
	"../Reports/Operations/operational-report/daily-order-count-report/daily-order-count-report.module": [
		"./src/app/Reports/Operations/operational-report/daily-order-count-report/daily-order-count-report.module.ts",
		"Reports-Operations-operational-report-daily-order-count-report-daily-order-count-report-module"
	],
	"../Reports/Operations/operational-report/daily-orders-count-by-branch-and-customer-report/daily-orders-count-by-branch-and-customer-report.module": [
		"./src/app/Reports/Operations/operational-report/daily-orders-count-by-branch-and-customer-report/daily-orders-count-by-branch-and-customer-report.module.ts",
		"Reports-Operations-operational-report-daily-orders-count-by-branch-and-customer-report-daily-orders-count-by-branch-and-customer-report-module"
	],
	"../Reports/Operations/operational-report/daily-trip-delivery-performance/daily-trip-delivery-performance.module": [
		"./src/app/Reports/Operations/operational-report/daily-trip-delivery-performance/daily-trip-delivery-performance.module.ts",
		"Reports-Operations-operational-report-daily-trip-delivery-performance-daily-trip-delivery-performance-module"
	],
	"../Reports/Operations/operational-report/daily-trips-report/daily-trips-report.module": [
		"./src/app/Reports/Operations/operational-report/daily-trips-report/daily-trips-report.module.ts",
		"Reports-Operations-operational-report-daily-trips-report-daily-trips-report-module"
	],
	"../Reports/Operations/operational-report/daily-trips-v2/daily-trips-v2.module": [
		"./src/app/Reports/Operations/operational-report/daily-trips-v2/daily-trips-v2.module.ts",
		"Reports-Operations-operational-report-daily-trips-v2-daily-trips-v2-module"
	],
	"../Reports/Operations/operational-report/dailyTripStatus/dailyTripStatus.module": [
		"./src/app/Reports/Operations/operational-report/dailyTripStatus/dailyTripStatus.module.ts",
		"Reports-Operations-operational-report-dailyTripStatus-dailyTripStatus-module"
	],
	"../Reports/Operations/operational-report/deleted-transactions/deleted-transactions.module": [
		"./src/app/Reports/Operations/operational-report/deleted-transactions/deleted-transactions.module.ts",
		"Reports-Operations-operational-report-deleted-transactions-deleted-transactions-module"
	],
	"../Reports/Operations/operational-report/destination-gate-register-report/destination-gate-register-report.module": [
		"./src/app/Reports/Operations/operational-report/destination-gate-register-report/destination-gate-register-report.module.ts",
		"Reports-Operations-operational-report-destination-gate-register-report-destination-gate-register-report-module"
	],
	"../Reports/Operations/operational-report/dispatchreportlist/dispatchreportlist.module": [
		"./src/app/Reports/Operations/operational-report/dispatchreportlist/dispatchreportlist.module.ts",
		"Reports-Operations-operational-report-dispatchreportlist-dispatchreportlist-module"
	],
	"../Reports/Operations/operational-report/distance-travelled/distance-travelled.module": [
		"./src/app/Reports/Operations/operational-report/distance-travelled/distance-travelled.module.ts",
		"Reports-Operations-operational-report-distance-travelled-distance-travelled-module"
	],
	"../Reports/Operations/operational-report/dmr-report/dmr-report.module": [
		"./src/app/Reports/Operations/operational-report/dmr-report/dmr-report.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~60cdf2c0",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"default~Bookings-TripDocumentPrint-TripDocumentPrint-module~Reports-Operations-operational-report-dm~fd36d866",
		"common",
		"Reports-Operations-operational-report-dmr-report-dmr-report-module"
	],
	"../Reports/Operations/operational-report/dmr-summary-report/dmr-summary-report.module": [
		"./src/app/Reports/Operations/operational-report/dmr-summary-report/dmr-summary-report.module.ts",
		"Reports-Operations-operational-report-dmr-summary-report-dmr-summary-report-module"
	],
	"../Reports/Operations/operational-report/driver-net-sales/driver-net-sales.module": [
		"./src/app/Reports/Operations/operational-report/driver-net-sales/driver-net-sales.module.ts",
		"Reports-Operations-operational-report-driver-net-sales-driver-net-sales-module"
	],
	"../Reports/Operations/operational-report/driver-salary-report/driver-salary-report.module": [
		"./src/app/Reports/Operations/operational-report/driver-salary-report/driver-salary-report.module.ts",
		"Reports-Operations-operational-report-driver-salary-report-driver-salary-report-module"
	],
	"../Reports/Operations/operational-report/expectedactualtrip-report/expectedactualtrip-report.module": [
		"./src/app/Reports/Operations/operational-report/expectedactualtrip-report/expectedactualtrip-report.module.ts",
		"Reports-Operations-operational-report-expectedactualtrip-report-expectedactualtrip-report-module"
	],
	"../Reports/Operations/operational-report/frequentcollectiondelay/frequentcollectiondelay.module": [
		"./src/app/Reports/Operations/operational-report/frequentcollectiondelay/frequentcollectiondelay.module.ts",
		"Reports-Operations-operational-report-frequentcollectiondelay-frequentcollectiondelay-module"
	],
	"../Reports/Operations/operational-report/indent-by-branch-and-by-delivery-city-report/indent-by-branch-and-by-delivery-city-report.module": [
		"./src/app/Reports/Operations/operational-report/indent-by-branch-and-by-delivery-city-report/indent-by-branch-and-by-delivery-city-report.module.ts",
		"Reports-Operations-operational-report-indent-by-branch-and-by-delivery-city-report-indent-by-branch-and-by-delivery-city-report-module"
	],
	"../Reports/Operations/operational-report/jsongenerator/jsongenerator.module": [
		"./src/app/Reports/Operations/operational-report/jsongenerator/jsongenerator.module.ts",
		"Reports-Operations-operational-report-jsongenerator-jsongenerator-module"
	],
	"../Reports/Operations/operational-report/lm_OrdersSummaryReport/lm_OrdersSummaryReport.module": [
		"./src/app/Reports/Operations/operational-report/lm_OrdersSummaryReport/lm_OrdersSummaryReport.module.ts",
		"Reports-Operations-operational-report-lm_OrdersSummaryReport-lm_OrdersSummaryReport-module"
	],
	"../Reports/Operations/operational-report/lm_collectionReconciliation/lm_collectionReconciliation.module": [
		"./src/app/Reports/Operations/operational-report/lm_collectionReconciliation/lm_collectionReconciliation.module.ts",
		"Reports-Operations-operational-report-lm_collectionReconciliation-lm_collectionReconciliation-module"
	],
	"../Reports/Operations/operational-report/lrwise-income-expense/lrwise-income-expense.module": [
		"./src/app/Reports/Operations/operational-report/lrwise-income-expense/lrwise-income-expense.module.ts",
		"Reports-Operations-operational-report-lrwise-income-expense-lrwise-income-expense-module"
	],
	"../Reports/Operations/operational-report/monthly-order-by-customer-type-of-services-report/monthly-order-by-customer-type-of-services-report.module": [
		"./src/app/Reports/Operations/operational-report/monthly-order-by-customer-type-of-services-report/monthly-order-by-customer-type-of-services-report.module.ts",
		"Reports-Operations-operational-report-monthly-order-by-customer-type-of-services-report-monthly-order-by-customer-type-of-services-report-module"
	],
	"../Reports/Operations/operational-report/monthly-order-count-report/monthly-order-count-report.module": [
		"./src/app/Reports/Operations/operational-report/monthly-order-count-report/monthly-order-count-report.module.ts",
		"Reports-Operations-operational-report-monthly-order-count-report-monthly-order-count-report-module"
	],
	"../Reports/Operations/operational-report/monthly-orders-count-by-branch-and-customer-report/monthly-orders-count-by-branch-and-customer-report.module": [
		"./src/app/Reports/Operations/operational-report/monthly-orders-count-by-branch-and-customer-report/monthly-orders-count-by-branch-and-customer-report.module.ts",
		"Reports-Operations-operational-report-monthly-orders-count-by-branch-and-customer-report-monthly-orders-count-by-branch-and-customer-report-module"
	],
	"../Reports/Operations/operational-report/opa_BagHistoryReport/opa_BagHistoryReport.module": [
		"./src/app/Reports/Operations/operational-report/opa_BagHistoryReport/opa_BagHistoryReport.module.ts",
		"Reports-Operations-operational-report-opa_BagHistoryReport-opa_BagHistoryReport-module"
	],
	"../Reports/Operations/operational-report/opa_BagInventoryReport/opa_BagInventoryReport.module": [
		"./src/app/Reports/Operations/operational-report/opa_BagInventoryReport/opa_BagInventoryReport.module.ts",
		"Reports-Operations-operational-report-opa_BagInventoryReport-opa_BagInventoryReport-module"
	],
	"../Reports/Operations/operational-report/opa_TamperedBagReport/opa_TamperedBagReport.module": [
		"./src/app/Reports/Operations/operational-report/opa_TamperedBagReport/opa_TamperedBagReport.module.ts",
		"Reports-Operations-operational-report-opa_TamperedBagReport-opa_TamperedBagReport-module"
	],
	"../Reports/Operations/operational-report/operational-report.module": [
		"./src/app/Reports/Operations/operational-report/operational-report.module.ts",
		"Reports-Operations-operational-report-operational-report-module"
	],
	"../Reports/Operations/operational-report/ops-damage-report/ops-damage-report.module": [
		"./src/app/Reports/Operations/operational-report/ops-damage-report/ops-damage-report.module.ts",
		"Reports-Operations-operational-report-ops-damage-report-ops-damage-report-module"
	],
	"../Reports/Operations/operational-report/ops-dispatch-summary-report/ops-dispatch-summary-report.module": [
		"./src/app/Reports/Operations/operational-report/ops-dispatch-summary-report/ops-dispatch-summary-report.module.ts",
		"Reports-Operations-operational-report-ops-dispatch-summary-report-ops-dispatch-summary-report-module"
	],
	"../Reports/Operations/operational-report/ops-driver-performance-report/ops-driver-performance-report.module": [
		"./src/app/Reports/Operations/operational-report/ops-driver-performance-report/ops-driver-performance-report.module.ts",
		"Reports-Operations-operational-report-ops-driver-performance-report-ops-driver-performance-report-module"
	],
	"../Reports/Operations/operational-report/ops-manpower-productivity-report/ops-manpower-productivity-report.module": [
		"./src/app/Reports/Operations/operational-report/ops-manpower-productivity-report/ops-manpower-productivity-report.module.ts",
		"Reports-Operations-operational-report-ops-manpower-productivity-report-ops-manpower-productivity-report-module"
	],
	"../Reports/Operations/operational-report/ops-revese-pickup-report/ops-revese-pickup-report.module": [
		"./src/app/Reports/Operations/operational-report/ops-revese-pickup-report/ops-revese-pickup-report.module.ts",
		"Reports-Operations-operational-report-ops-revese-pickup-report-ops-revese-pickup-report-module"
	],
	"../Reports/Operations/operational-report/order-cancelled-report/order-cancelled-report.module": [
		"./src/app/Reports/Operations/operational-report/order-cancelled-report/order-cancelled-report.module.ts",
		"Reports-Operations-operational-report-order-cancelled-report-order-cancelled-report-module"
	],
	"../Reports/Operations/operational-report/order-integration-log/OrderIntegrationlog.module": [
		"./src/app/Reports/Operations/operational-report/order-integration-log/OrderIntegrationlog.module.ts",
		"Reports-Operations-operational-report-order-integration-log-OrderIntegrationlog-module"
	],
	"../Reports/Operations/operational-report/orderlisttripwise/orderlisttripwise.module": [
		"./src/app/Reports/Operations/operational-report/orderlisttripwise/orderlisttripwise.module.ts",
		"Reports-Operations-operational-report-orderlisttripwise-orderlisttripwise-module"
	],
	"../Reports/Operations/operational-report/origin-gate-register-report/origin-gate-register-report.module": [
		"./src/app/Reports/Operations/operational-report/origin-gate-register-report/origin-gate-register-report.module.ts",
		"Reports-Operations-operational-report-origin-gate-register-report-origin-gate-register-report-module"
	],
	"../Reports/Operations/operational-report/ot-orderwiseincomeexpense/ot-orderwiseincomeexpense.module": [
		"./src/app/Reports/Operations/operational-report/ot-orderwiseincomeexpense/ot-orderwiseincomeexpense.module.ts",
		"Reports-Operations-operational-report-ot-orderwiseincomeexpense-ot-orderwiseincomeexpense-module"
	],
	"../Reports/Operations/operational-report/ot_DEPSReport/ot_DEPSReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_DEPSReport/ot_DEPSReport.module.ts",
		"Reports-Operations-operational-report-ot_DEPSReport-ot_DEPSReport-module"
	],
	"../Reports/Operations/operational-report/ot_DestinationScannedReport/ot_DestinationScannedReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_DestinationScannedReport/ot_DestinationScannedReport.module.ts",
		"Reports-Operations-operational-report-ot_DestinationScannedReport-ot_DestinationScannedReport-module"
	],
	"../Reports/Operations/operational-report/ot_DispatchReport/ot_DispatchReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_DispatchReport/ot_DispatchReport.module.ts",
		"Reports-Operations-operational-report-ot_DispatchReport-ot_DispatchReport-module"
	],
	"../Reports/Operations/operational-report/ot_PendingDispatchReport/ot_PendingDispatchReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_PendingDispatchReport/ot_PendingDispatchReport.module.ts",
		"Reports-Operations-operational-report-ot_PendingDispatchReport-ot_PendingDispatchReport-module"
	],
	"../Reports/Operations/operational-report/ot_ReceivedScannedReport/ot_ReceivedScannedReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_ReceivedScannedReport/ot_ReceivedScannedReport.module.ts",
		"Reports-Operations-operational-report-ot_ReceivedScannedReport-ot_ReceivedScannedReport-module"
	],
	"../Reports/Operations/operational-report/ot_ShipmentTrackingReport/ot_ShipmentTrackingReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_ShipmentTrackingReport/ot_ShipmentTrackingReport.module.ts",
		"Reports-Operations-operational-report-ot_ShipmentTrackingReport-ot_ShipmentTrackingReport-module"
	],
	"../Reports/Operations/operational-report/ot_materReport/ot_materReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_materReport/ot_materReport.module.ts",
		"Reports-Operations-operational-report-ot_materReport-ot_materReport-module"
	],
	"../Reports/Operations/operational-report/ot_vehicleDispatchPerformanceReport/ot_vehicleDispatchPerformanceReport.module": [
		"./src/app/Reports/Operations/operational-report/ot_vehicleDispatchPerformanceReport/ot_vehicleDispatchPerformanceReport.module.ts",
		"Reports-Operations-operational-report-ot_vehicleDispatchPerformanceReport-ot_vehicleDispatchPerformanceReport-module"
	],
	"../Reports/Operations/operational-report/pending-trip/pending-trip.module": [
		"./src/app/Reports/Operations/operational-report/pending-trip/pending-trip.module.ts",
		"Reports-Operations-operational-report-pending-trip-pending-trip-module"
	],
	"../Reports/Operations/operational-report/reimbursement-income-expense/reimbursementincomeexpense.module": [
		"./src/app/Reports/Operations/operational-report/reimbursement-income-expense/reimbursementincomeexpense.module.ts",
		"Reports-Operations-operational-report-reimbursement-income-expense-reimbursementincomeexpense-module"
	],
	"../Reports/Operations/operational-report/route-violations-report/route-violations-report.module": [
		"./src/app/Reports/Operations/operational-report/route-violations-report/route-violations-report.module.ts",
		"Reports-Operations-operational-report-route-violations-report-route-violations-report-module"
	],
	"../Reports/Operations/operational-report/rp_op_CaretDetail/rp_op_CaretDetail.module": [
		"./src/app/Reports/Operations/operational-report/rp_op_CaretDetail/rp_op_CaretDetail.module.ts",
		"Reports-Operations-operational-report-rp_op_CaretDetail-rp_op_CaretDetail-module"
	],
	"../Reports/Operations/operational-report/rp_op_CaretSummary/rp_op_CaretSummary.module": [
		"./src/app/Reports/Operations/operational-report/rp_op_CaretSummary/rp_op_CaretSummary.module.ts",
		"Reports-Operations-operational-report-rp_op_CaretSummary-rp_op_CaretSummary-module"
	],
	"../Reports/Operations/operational-report/sales-return-report/sales-return-report.module": [
		"./src/app/Reports/Operations/operational-report/sales-return-report/sales-return-report.module.ts",
		"Reports-Operations-operational-report-sales-return-report-sales-return-report-module"
	],
	"../Reports/Operations/operational-report/sapsentreport/sapsentreport.component.module": [
		"./src/app/Reports/Operations/operational-report/sapsentreport/sapsentreport.component.module.ts",
		"Reports-Operations-operational-report-sapsentreport-sapsentreport-component-module"
	],
	"../Reports/Operations/operational-report/sim-tracking-summary-report/sim-tracking-summary-report.module": [
		"./src/app/Reports/Operations/operational-report/sim-tracking-summary-report/sim-tracking-summary-report.module.ts",
		"Reports-Operations-operational-report-sim-tracking-summary-report-sim-tracking-summary-report-module"
	],
	"../Reports/Operations/operational-report/tonage-report/tonage-report.module": [
		"./src/app/Reports/Operations/operational-report/tonage-report/tonage-report.module.ts",
		"Reports-Operations-operational-report-tonage-report-tonage-report-module"
	],
	"../Reports/Operations/operational-report/trip-cancelled-report/trip-cancelled-report.module": [
		"./src/app/Reports/Operations/operational-report/trip-cancelled-report/trip-cancelled-report.module.ts",
		"Reports-Operations-operational-report-trip-cancelled-report-trip-cancelled-report-module"
	],
	"../Reports/Operations/operational-report/trip-count-data-report/trip-count-data-report.module": [
		"./src/app/Reports/Operations/operational-report/trip-count-data-report/trip-count-data-report.module.ts",
		"Reports-Operations-operational-report-trip-count-data-report-trip-count-data-report-module"
	],
	"../Reports/Operations/operational-report/trip-expense-charge-wise/trip-expense-charge-wise.module": [
		"./src/app/Reports/Operations/operational-report/trip-expense-charge-wise/trip-expense-charge-wise.module.ts",
		"Reports-Operations-operational-report-trip-expense-charge-wise-trip-expense-charge-wise-module"
	],
	"../Reports/Operations/operational-report/trip-status-by-tat/trip-status-by-tat.module": [
		"./src/app/Reports/Operations/operational-report/trip-status-by-tat/trip-status-by-tat.module.ts",
		"Reports-Operations-operational-report-trip-status-by-tat-trip-status-by-tat-module"
	],
	"../Reports/Operations/operational-report/trip-status-by-trip-expense/trip-status-by-trip-expense.module": [
		"./src/app/Reports/Operations/operational-report/trip-status-by-trip-expense/trip-status-by-trip-expense.module.ts",
		"Reports-Operations-operational-report-trip-status-by-trip-expense-trip-status-by-trip-expense-module"
	],
	"../Reports/Operations/operational-report/trip-staus-report/trip-staus-report.module": [
		"./src/app/Reports/Operations/operational-report/trip-staus-report/trip-staus-report.module.ts",
		"Reports-Operations-operational-report-trip-staus-report-trip-staus-report-module"
	],
	"../Reports/Operations/operational-report/trip-wise-income-expense/trip-wise-income-expense.module": [
		"./src/app/Reports/Operations/operational-report/trip-wise-income-expense/trip-wise-income-expense.module.ts",
		"Reports-Operations-operational-report-trip-wise-income-expense-trip-wise-income-expense-module"
	],
	"../Reports/Operations/operational-report/trip_IncomeExpenseChargeWiseReport/trip_IncomeExpenseChargeWiseReport.module": [
		"./src/app/Reports/Operations/operational-report/trip_IncomeExpenseChargeWiseReport/trip_IncomeExpenseChargeWiseReport.module.ts",
		"Reports-Operations-operational-report-trip_IncomeExpenseChargeWiseReport-trip_IncomeExpenseChargeWiseReport-module"
	],
	"../Reports/Operations/operational-report/tripstatussummaryreport/tripstatussummaryreport.module": [
		"./src/app/Reports/Operations/operational-report/tripstatussummaryreport/tripstatussummaryreport.module.ts",
		"Reports-Operations-operational-report-tripstatussummaryreport-tripstatussummaryreport-module"
	],
	"../Reports/Operations/operational-report/tyre-history-report/tyre-history-report.module": [
		"./src/app/Reports/Operations/operational-report/tyre-history-report/tyre-history-report.module.ts",
		"Reports-Operations-operational-report-tyre-history-report-tyre-history-report-module"
	],
	"../Reports/Operations/operational-report/tyre-list-report/tyre-list-report.module": [
		"./src/app/Reports/Operations/operational-report/tyre-list-report/tyre-list-report.module.ts",
		"Reports-Operations-operational-report-tyre-list-report-tyre-list-report-module"
	],
	"../Reports/Operations/operational-report/userheirarchy/userheirarchy.module": [
		"./src/app/Reports/Operations/operational-report/userheirarchy/userheirarchy.module.ts",
		"Reports-Operations-operational-report-userheirarchy-userheirarchy-module"
	],
	"../Reports/Operations/operational-report/vechicle repairs and maintenance/vechicle.module": [
		"./src/app/Reports/Operations/operational-report/vechicle repairs and maintenance/vechicle.module.ts",
		"Reports-Operations-operational-report-vechicle-repairs-and-maintenance-vechicle-module"
	],
	"../Reports/Operations/operational-report/vehicle-alert-report/vehicle-alert-report.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-alert-report/vehicle-alert-report.module.ts",
		"Reports-Operations-operational-report-vehicle-alert-report-vehicle-alert-report-module"
	],
	"../Reports/Operations/operational-report/vehicle-destination-performance/vehicle-destination-performance.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-destination-performance/vehicle-destination-performance.module.ts",
		"Reports-Operations-operational-report-vehicle-destination-performance-vehicle-destination-performance-module"
	],
	"../Reports/Operations/operational-report/vehicle-diesel-mileage/vehicle-diesel-mileage.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-diesel-mileage/vehicle-diesel-mileage.module.ts",
		"Reports-Operations-operational-report-vehicle-diesel-mileage-vehicle-diesel-mileage-module"
	],
	"../Reports/Operations/operational-report/vehicle-history/vehicle-history.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-history/vehicle-history.module.ts",
		"Reports-Operations-operational-report-vehicle-history-vehicle-history-module"
	],
	"../Reports/Operations/operational-report/vehicle-loading-performance/vehicle-loading-performance.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-loading-performance/vehicle-loading-performance.module.ts",
		"Reports-Operations-operational-report-vehicle-loading-performance-vehicle-loading-performance-module"
	],
	"../Reports/Operations/operational-report/vehicle-origin-performance/vehicle-origin-performance.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-origin-performance/vehicle-origin-performance.module.ts",
		"Reports-Operations-operational-report-vehicle-origin-performance-vehicle-origin-performance-module"
	],
	"../Reports/Operations/operational-report/vehicle-trip-expense-report/vehicle-trip-expense-report.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-trip-expense-report/vehicle-trip-expense-report.module.ts",
		"Reports-Operations-operational-report-vehicle-trip-expense-report-vehicle-trip-expense-report-module"
	],
	"../Reports/Operations/operational-report/vehicle-utilization/vehicle-utilization.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-utilization/vehicle-utilization.module.ts",
		"Reports-Operations-operational-report-vehicle-utilization-vehicle-utilization-module"
	],
	"../Reports/Operations/operational-report/vehicle-wise-monthly-calendar/vehicle-wise-monthly-calendar.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-wise-monthly-calendar/vehicle-wise-monthly-calendar.module.ts",
		"Reports-Operations-operational-report-vehicle-wise-monthly-calendar-vehicle-wise-monthly-calendar-module"
	],
	"../Reports/Operations/operational-report/vehicle-wise-tyre-report/vehicle-wise-tyre-report.module": [
		"./src/app/Reports/Operations/operational-report/vehicle-wise-tyre-report/vehicle-wise-tyre-report.module.ts",
		"Reports-Operations-operational-report-vehicle-wise-tyre-report-vehicle-wise-tyre-report-module"
	],
	"../Reports/Operations/operational-report/vehicleloadutilizationbytrip/vehicleloadutilizationbytrip.module": [
		"./src/app/Reports/Operations/operational-report/vehicleloadutilizationbytrip/vehicleloadutilizationbytrip.module.ts",
		"Reports-Operations-operational-report-vehicleloadutilizationbytrip-vehicleloadutilizationbytrip-module"
	],
	"../Reports/Transportation_Report/Transportation_Report.module": [
		"./src/app/Reports/Transportation_Report/Transportation_Report.module.ts",
		"Reports-Transportation_Report-Transportation_Report-module"
	],
	"../Reports/Transportation_Report/rpt_ex_FreightSpentByInvoice/rpt_ex_FreightSpentByInvoice.module": [
		"./src/app/Reports/Transportation_Report/rpt_ex_FreightSpentByInvoice/rpt_ex_FreightSpentByInvoice.module.ts",
		"Reports-Transportation_Report-rpt_ex_FreightSpentByInvoice-rpt_ex_FreightSpentByInvoice-module"
	],
	"../Reports/Transportation_Report/rpt_ex_TripExpenseSummary/rpt_ex_TripExpenseSummary.module": [
		"./src/app/Reports/Transportation_Report/rpt_ex_TripExpenseSummary/rpt_ex_TripExpenseSummary.module.ts",
		"Reports-Transportation_Report-rpt_ex_TripExpenseSummary-rpt_ex_TripExpenseSummary-module"
	],
	"../Reports/Transportation_Report/rpt_ex_TripStatus/rpt_ex_TripStatus.module": [
		"./src/app/Reports/Transportation_Report/rpt_ex_TripStatus/rpt_ex_TripStatus.module.ts",
		"Reports-Transportation_Report-rpt_ex_TripStatus-rpt_ex_TripStatus-module"
	],
	"../Reports/Transportation_Report/rpt_ex_TripStatusByOrder/rpt_ex_TripStatusByOrder.module": [
		"./src/app/Reports/Transportation_Report/rpt_ex_TripStatusByOrder/rpt_ex_TripStatusByOrder.module.ts",
		"Reports-Transportation_Report-rpt_ex_TripStatusByOrder-rpt_ex_TripStatusByOrder-module"
	],
	"../Reports/finance/finance.module": [
		"./src/app/Reports/finance/finance.module.ts",
		"Reports-finance-finance-module"
	],
	"../Reports/new-operations-rept/new-allocateddriveridletime/new-allocateddriveridletime.module": [
		"./src/app/Reports/new-operations-rept/new-allocateddriveridletime/new-allocateddriveridletime.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-allocateddriveridletime-new-allocateddriveridletime-module"
	],
	"../Reports/new-operations-rept/new-bidding-report/new-bidding-report.module": [
		"./src/app/Reports/new-operations-rept/new-bidding-report/new-bidding-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-bidding-report-new-bidding-report-module"
	],
	"../Reports/new-operations-rept/new-daily-operationalreportdetails/new-daily-operationalreportdetails.module": [
		"./src/app/Reports/new-operations-rept/new-daily-operationalreportdetails/new-daily-operationalreportdetails.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-daily-operationalreportdetails-new-daily-operationalreportdetails-module"
	],
	"../Reports/new-operations-rept/new-destination-gate-register-report/new-destination-gate-register-report.module": [
		"./src/app/Reports/new-operations-rept/new-destination-gate-register-report/new-destination-gate-register-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-destination-gate-register-report-new-destination-gate-register-report-module"
	],
	"../Reports/new-operations-rept/new-driver-net-sales/new-driver-net-sales.module": [
		"./src/app/Reports/new-operations-rept/new-driver-net-sales/new-driver-net-sales.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-driver-net-sales-new-driver-net-sales-module"
	],
	"../Reports/new-operations-rept/new-freight-spent/new-freight-spent.module": [
		"./src/app/Reports/new-operations-rept/new-freight-spent/new-freight-spent.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-freight-spent-new-freight-spent-module"
	],
	"../Reports/new-operations-rept/new-frequentcollectiondelay/new-frequentcollectiondelay.module": [
		"./src/app/Reports/new-operations-rept/new-frequentcollectiondelay/new-frequentcollectiondelay.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-frequentcollectiondelay-new-frequentcollectiondelay-module"
	],
	"../Reports/new-operations-rept/new-indent-by-branch-and-by-delivery-city-report/new-indent-by-branch-and-by-delivery-city-report.module": [
		"./src/app/Reports/new-operations-rept/new-indent-by-branch-and-by-delivery-city-report/new-indent-by-branch-and-by-delivery-city-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-indent-by-branch-and-by-delivery-city-report-new-indent-by-branch-and-by-delivery-city-report-module"
	],
	"../Reports/new-operations-rept/new-job-profitabilityreport/new-job-profitabilityreport.module": [
		"./src/app/Reports/new-operations-rept/new-job-profitabilityreport/new-job-profitabilityreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-job-profitabilityreport-new-job-profitabilityreport-module"
	],
	"../Reports/new-operations-rept/new-locationwise-delivery-points/new-locationwise-delivery-points.module": [
		"./src/app/Reports/new-operations-rept/new-locationwise-delivery-points/new-locationwise-delivery-points.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-locationwise-delivery-points-new-locationwise-delivery-points-module"
	],
	"../Reports/new-operations-rept/new-locationwise-invoicesmade-report/new-locationwise-invoicesmade-report.module": [
		"./src/app/Reports/new-operations-rept/new-locationwise-invoicesmade-report/new-locationwise-invoicesmade-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-locationwise-invoicesmade-report-new-locationwise-invoicesmade-report-module"
	],
	"../Reports/new-operations-rept/new-locationwise-shiptoparties-report/new-locationwise-shiptoparties-report.module": [
		"./src/app/Reports/new-operations-rept/new-locationwise-shiptoparties-report/new-locationwise-shiptoparties-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-locationwise-shiptoparties-report-new-locationwise-shiptoparties-report-module"
	],
	"../Reports/new-operations-rept/new-locationwiseboxeshandled/new-locationwiseboxeshandled.module": [
		"./src/app/Reports/new-operations-rept/new-locationwiseboxeshandled/new-locationwiseboxeshandled.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-locationwiseboxeshandled-new-locationwiseboxeshandled-module"
	],
	"../Reports/new-operations-rept/new-locationwisekmcovered/new-locationwisekmcovered.module": [
		"./src/app/Reports/new-operations-rept/new-locationwisekmcovered/new-locationwisekmcovered.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-locationwisekmcovered-new-locationwisekmcovered-module"
	],
	"../Reports/new-operations-rept/new-locationwisetransporters/new-locationwisetransporters.module": [
		"./src/app/Reports/new-operations-rept/new-locationwisetransporters/new-locationwisetransporters.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-locationwisetransporters-new-locationwisetransporters-module"
	],
	"../Reports/new-operations-rept/new-locationwisevehiclesused/new-locationwisevehiclesused.module": [
		"./src/app/Reports/new-operations-rept/new-locationwisevehiclesused/new-locationwisevehiclesused.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-locationwisevehiclesused-new-locationwisevehiclesused-module"
	],
	"../Reports/new-operations-rept/new-lrwise-income-expense/new-lrwise-income-expense.module": [
		"./src/app/Reports/new-operations-rept/new-lrwise-income-expense/new-lrwise-income-expense.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-lrwise-income-expense-new-lrwise-income-expense-module"
	],
	"../Reports/new-operations-rept/new-operations-daily-trips-report/new-operations-daily-trips-report.module": [
		"./src/app/Reports/new-operations-rept/new-operations-daily-trips-report/new-operations-daily-trips-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-operations-daily-trips-report-new-operations-daily-trips-report-module"
	],
	"../Reports/new-operations-rept/new-operations-dmrreport/new-operations-dmrreport.module": [
		"./src/app/Reports/new-operations-rept/new-operations-dmrreport/new-operations-dmrreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-operations-dmrreport-new-operations-dmrreport-module"
	],
	"../Reports/new-operations-rept/new-operations-dmrsummary-report/new-operations-dmrsummary-report.module": [
		"./src/app/Reports/new-operations-rept/new-operations-dmrsummary-report/new-operations-dmrsummary-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-operations-dmrsummary-report-new-operations-dmrsummary-report-module"
	],
	"../Reports/new-operations-rept/new-operations-rept.module": [
		"./src/app/Reports/new-operations-rept/new-operations-rept.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Reports-new-operations-rept-new-operations-rept-module~Reports-new-operations-rept-tyre-hist~c08ca400",
		"default~Reports-new-operations-rept-new-operations-rept-module~Reports-new-operations-rept-tyre-list~bc1c7232",
		"common",
		"Reports-new-operations-rept-new-operations-rept-module"
	],
	"../Reports/new-operations-rept/new-ordercancelled-report/new-ordercancelled-report.module": [
		"./src/app/Reports/new-operations-rept/new-ordercancelled-report/new-ordercancelled-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-ordercancelled-report-new-ordercancelled-report-module"
	],
	"../Reports/new-operations-rept/new-orderlistbytrip-report/new-orderlistbytrip-report.module": [
		"./src/app/Reports/new-operations-rept/new-orderlistbytrip-report/new-orderlistbytrip-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-orderlistbytrip-report-new-orderlistbytrip-report-module"
	],
	"../Reports/new-operations-rept/new-orderslist-report/new-orderslist-report.module": [
		"./src/app/Reports/new-operations-rept/new-orderslist-report/new-orderslist-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-orderslist-report-new-orderslist-report-module"
	],
	"../Reports/new-operations-rept/new-origin-gateregister-report/new-origin-gateregister-report.module": [
		"./src/app/Reports/new-operations-rept/new-origin-gateregister-report/new-origin-gateregister-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-origin-gateregister-report-new-origin-gateregister-report-module"
	],
	"../Reports/new-operations-rept/new-payment-exceptions/new-payment-exceptions.module": [
		"./src/app/Reports/new-operations-rept/new-payment-exceptions/new-payment-exceptions.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-payment-exceptions-new-payment-exceptions-module"
	],
	"../Reports/new-operations-rept/new-sales-return-report/new-sales-return-report.module": [
		"./src/app/Reports/new-operations-rept/new-sales-return-report/new-sales-return-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-sales-return-report-new-sales-return-report-module"
	],
	"../Reports/new-operations-rept/new-trip-status-rept/new-trip-status-rept.module": [
		"./src/app/Reports/new-operations-rept/new-trip-status-rept/new-trip-status-rept.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-trip-status-rept-new-trip-status-rept-module"
	],
	"../Reports/new-operations-rept/new-trip-statusreport/new-trip-statusreport.module": [
		"./src/app/Reports/new-operations-rept/new-trip-statusreport/new-trip-statusreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-trip-statusreport-new-trip-statusreport-module"
	],
	"../Reports/new-operations-rept/new-tripcancelled-report/new-tripcancelled-report.module": [
		"./src/app/Reports/new-operations-rept/new-tripcancelled-report/new-tripcancelled-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-tripcancelled-report-new-tripcancelled-report-module"
	],
	"../Reports/new-operations-rept/new-tripincomeexpensechargewisereport/new-tripincomeexpensechargewisereport.module": [
		"./src/app/Reports/new-operations-rept/new-tripincomeexpensechargewisereport/new-tripincomeexpensechargewisereport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-tripincomeexpensechargewisereport-new-tripincomeexpensechargewisereport-module"
	],
	"../Reports/new-operations-rept/new-tripincomeexpensewithpaymentreport/new-tripincomeexpensewithpaymentreport.module": [
		"./src/app/Reports/new-operations-rept/new-tripincomeexpensewithpaymentreport/new-tripincomeexpensewithpaymentreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-tripincomeexpensewithpaymentreport-new-tripincomeexpensewithpaymentreport-module"
	],
	"../Reports/new-operations-rept/new-tripstatus-summeryreport/new-tripstatus-summeryreport.module": [
		"./src/app/Reports/new-operations-rept/new-tripstatus-summeryreport/new-tripstatus-summeryreport.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-tripstatus-summeryreport-new-tripstatus-summeryreport-module"
	],
	"../Reports/new-operations-rept/new-tripstatusbytripexpense/new-tripstatusbytripexpense.module": [
		"./src/app/Reports/new-operations-rept/new-tripstatusbytripexpense/new-tripstatusbytripexpense.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-tripstatusbytripexpense-new-tripstatusbytripexpense-module"
	],
	"../Reports/new-operations-rept/new-tripwise-income-expense/new-tripwise-income-expense.module": [
		"./src/app/Reports/new-operations-rept/new-tripwise-income-expense/new-tripwise-income-expense.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-tripwise-income-expense-new-tripwise-income-expense-module"
	],
	"../Reports/new-operations-rept/new-vehicle-trip-expense-report/new-vehicle-trip-expense-report.module": [
		"./src/app/Reports/new-operations-rept/new-vehicle-trip-expense-report/new-vehicle-trip-expense-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-new-vehicle-trip-expense-report-new-vehicle-trip-expense-report-module"
	],
	"../Reports/new-operations-rept/rp_op_JobProfitability_Summary/rp_op_JobProfitability_Summary.module": [
		"./src/app/Reports/new-operations-rept/rp_op_JobProfitability_Summary/rp_op_JobProfitability_Summary.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-rp_op_JobProfitability_Summary-rp_op_JobProfitability_Summary-module"
	],
	"../Reports/new-operations-rept/salesman-detail-report/salesman-detail-report.module": [
		"./src/app/Reports/new-operations-rept/salesman-detail-report/salesman-detail-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-salesman-detail-report-salesman-detail-report-module"
	],
	"../Reports/new-operations-rept/salesman-summary-report/salesman-summary-report.module": [
		"./src/app/Reports/new-operations-rept/salesman-summary-report/salesman-summary-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-salesman-summary-report-salesman-summary-report-module"
	],
	"../Reports/new-operations-rept/sim-tracking-report/sim-tracking-report.module": [
		"./src/app/Reports/new-operations-rept/sim-tracking-report/sim-tracking-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-sim-tracking-report-sim-tracking-report-module"
	],
	"../Reports/new-operations-rept/sim-tracking-summary-report/sim-tracking-summary-report.module": [
		"./src/app/Reports/new-operations-rept/sim-tracking-summary-report/sim-tracking-summary-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-sim-tracking-summary-report-sim-tracking-summary-report-module"
	],
	"../Reports/new-operations-rept/tyre-history-new/tyre-history-new.module": [
		"./src/app/Reports/new-operations-rept/tyre-history-new/tyre-history-new.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Reports-new-operations-rept-new-operations-rept-module~Reports-new-operations-rept-tyre-hist~c08ca400",
		"common",
		"Reports-new-operations-rept-tyre-history-new-tyre-history-new-module"
	],
	"../Reports/new-operations-rept/tyre-list-report/tyre-list-report.module": [
		"./src/app/Reports/new-operations-rept/tyre-list-report/tyre-list-report.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Reports-new-operations-rept-new-operations-rept-module~Reports-new-operations-rept-tyre-list~bc1c7232",
		"common",
		"Reports-new-operations-rept-tyre-list-report-tyre-list-report-module"
	],
	"../Reports/new-operations-rept/tyre-performance-report-new/tyre-performance-report-new.module": [
		"./src/app/Reports/new-operations-rept/tyre-performance-report-new/tyre-performance-report-new.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"Reports-new-operations-rept-tyre-performance-report-new-tyre-performance-report-new-module"
	],
	"../Sales/CashReceipt/CashReceipt.module": [
		"./src/app/Sales/CashReceipt/CashReceipt.module.ts",
		"Sales-CashReceipt-CashReceipt-module"
	],
	"../Sales/invoice-submission/invoice-submission.module": [
		"./src/app/Sales/invoice-submission/invoice-submission.module.ts",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"common",
		"Sales-invoice-submission-invoice-submission-module"
	],
	"../Sales/new-cash-receipt/new-cash-receipt.module": [
		"./src/app/Sales/new-cash-receipt/new-cash-receipt.module.ts",
		"Sales-new-cash-receipt-new-cash-receipt-module"
	],
	"../Sales/new-payment-received/new-payment-received.module": [
		"./src/app/Sales/new-payment-received/new-payment-received.module.ts",
		"Sales-new-payment-received-new-payment-received-module"
	],
	"../Sales/new-payment-req-sales/new-payment-req-sales.module": [
		"./src/app/Sales/new-payment-req-sales/new-payment-req-sales.module.ts",
		"Sales-new-payment-req-sales-new-payment-req-sales-module"
	],
	"../Sales/payment-received/payment-received.module": [
		"./src/app/Sales/payment-received/payment-received.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"common",
		"Sales-payment-received-payment-received-module"
	],
	"../Sales/payment-request-sales/payment-request-sales.module": [
		"./src/app/Sales/payment-request-sales/payment-request-sales.module.ts",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"common",
		"Sales-payment-request-sales-payment-request-sales-module"
	],
	"../Sales/pending-consignment/pending-consignment.module": [
		"./src/app/Sales/pending-consignment/pending-consignment.module.ts",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"common",
		"Sales-pending-consignment-pending-consignment-module"
	],
	"../Sales/pending-invoice-consignment/pending-invoice-consignment.module": [
		"./src/app/Sales/pending-invoice-consignment/pending-invoice-consignment.module.ts",
		"Sales-pending-invoice-consignment-pending-invoice-consignment-module"
	],
	"../Sales/sales-invoice-new/sales-invoice-new.module": [
		"./src/app/Sales/sales-invoice-new/sales-invoice-new.module.ts",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"common",
		"Sales-sales-invoice-new-sales-invoice-new-module"
	],
	"../Sales/sales-invoice/sales-invoice.module": [
		"./src/app/Sales/sales-invoice/sales-invoice.module.ts",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~3c332fbf",
		"default~Accouting-BankStatement-BankStatement-module~Accouting-balance-sheet-balance-sheet-module~Ac~08d08387",
		"default~Accouting-balance-sheet-balance-sheet-module~Accouting-general-ledger-general-ledger-module~~a3a578ed",
		"common",
		"Sales-sales-invoice-sales-invoice-module"
	],
	"../Salesman/Salesman.module": [
		"./src/app/Salesman/Salesman.module.ts",
		"Salesman-Salesman-module"
	],
	"../Utility/global-notes.module": [
		"./src/app/Utility/global-notes.module.ts",
		"Utility-global-notes-module"
	],
	"../Warehouse/Printscript-master/Printscript-master.module": [
		"./src/app/Warehouse/Printscript-master/Printscript-master.module.ts",
		"Warehouse-Printscript-master-Printscript-master-module"
	],
	"../Warehouse/Wharehouse_Reports/wh_Damage_Shortage_HoldReport/wh_Damage_Shortage_HoldReport.module": [
		"./src/app/Warehouse/Wharehouse_Reports/wh_Damage_Shortage_HoldReport/wh_Damage_Shortage_HoldReport.module.ts",
		"Warehouse-Wharehouse_Reports-wh_Damage_Shortage_HoldReport-wh_Damage_Shortage_HoldReport-module"
	],
	"../Warehouse/Wharehouse_Reports/wh_InwardRegister/wh_InwardRegister.module": [
		"./src/app/Warehouse/Wharehouse_Reports/wh_InwardRegister/wh_InwardRegister.module.ts",
		"Warehouse-Wharehouse_Reports-wh_InwardRegister-wh_InwardRegister-module"
	],
	"../Warehouse/Wharehouse_Reports/wh_OutwardRegister/wh_OutwardRegister.module": [
		"./src/app/Warehouse/Wharehouse_Reports/wh_OutwardRegister/wh_OutwardRegister.module.ts",
		"Warehouse-Wharehouse_Reports-wh_OutwardRegister-wh_OutwardRegister-module"
	],
	"../Warehouse/Wharehouse_Reports/wh_StockReport/wh_StockReport.module": [
		"./src/app/Warehouse/Wharehouse_Reports/wh_StockReport/wh_StockReport.module.ts",
		"Warehouse-Wharehouse_Reports-wh_StockReport-wh_StockReport-module"
	],
	"../Warehouse/Wharehouse_Reports/wh_reports.module": [
		"./src/app/Warehouse/Wharehouse_Reports/wh_reports.module.ts",
		"Warehouse-Wharehouse_Reports-wh_reports-module"
	],
	"../Warehouse/dimension-master/dimension-master.module": [
		"./src/app/Warehouse/dimension-master/dimension-master.module.ts",
		"Warehouse-dimension-master-dimension-master-module"
	],
	"../Warehouse/inwards/inwards.module": [
		"./src/app/Warehouse/inwards/inwards.module.ts",
		"Warehouse-inwards-inwards-module"
	],
	"../Warehouse/locationrestriction/locationrestriction.module": [
		"./src/app/Warehouse/locationrestriction/locationrestriction.module.ts",
		"Warehouse-locationrestriction-locationrestriction-module"
	],
	"../Warehouse/managelocation/generatelocationlist/generatelocationlist.module": [
		"./src/app/Warehouse/managelocation/generatelocationlist/generatelocationlist.module.ts",
		"Warehouse-managelocation-generatelocationlist-generatelocationlist-module"
	],
	"../Warehouse/managelocation/generatelocations/generatelocations.module": [
		"./src/app/Warehouse/managelocation/generatelocations/generatelocations.module.ts",
		"Warehouse-managelocation-generatelocations-generatelocations-module"
	],
	"../Warehouse/managelocation/locationhierarchy/locationhierarchy.module": [
		"./src/app/Warehouse/managelocation/locationhierarchy/locationhierarchy.module.ts",
		"Warehouse-managelocation-locationhierarchy-locationhierarchy-module"
	],
	"../Warehouse/managelocation/managelocation.module": [
		"./src/app/Warehouse/managelocation/managelocation.module.ts",
		"Warehouse-managelocation-managelocation-module"
	],
	"../Warehouse/outwards/outwards.module": [
		"./src/app/Warehouse/outwards/outwards.module.ts",
		"Warehouse-outwards-outwards-module"
	],
	"../Warehouse/warehousemaster/warehousemaster.module": [
		"./src/app/Warehouse/warehousemaster/warehousemaster.module.ts",
		"Warehouse-warehousemaster-warehousemaster-module"
	],
	"../Warehouse/warehousesettings/warehousesettings.module": [
		"./src/app/Warehouse/warehousesettings/warehousesettings.module.ts",
		"Warehouse-warehousesettings-warehousesettings-module"
	],
	"../beats/beats.module": [
		"./src/app/beats/beats.module.ts",
		"default~beats-beats-module~customer-beats-beats-module",
		"common",
		"beats-beats-module"
	],
	"../beats/new-beat/new-beat.module": [
		"./src/app/beats/new-beat/new-beat.module.ts",
		"beats-new-beat-new-beat-module"
	],
	"../dangerous-goods/dangerous-goods.module": [
		"./src/app/dangerous-goods/dangerous-goods.module.ts",
		"dangerous-goods-dangerous-goods-module"
	],
	"../documents/documents.module": [
		"./src/app/documents/documents.module.ts",
		"documents-documents-module"
	],
	"../eway-bill-log-detail/eway-bill-log-detail.module": [
		"./src/app/eway-bill-log-detail/eway-bill-log-detail.module.ts",
		"eway-bill-log-detail-eway-bill-log-detail-module"
	],
	"../feedback/feedback.module": [
		"./src/app/feedback/feedback.module.ts",
		"feedback-feedback-module"
	],
	"../freight-search/freight-search.module": [
		"./src/app/freight-search/freight-search.module.ts",
		"freight-search-freight-search-module"
	],
	"../full-truck-load/ftl-container-movement/ftl-container-movement.module": [
		"./src/app/full-truck-load/ftl-container-movement/ftl-container-movement.module.ts",
		"default~full-truck-load-ftl-container-movement-ftl-container-movement-module~full-truck-load-ftl-lis~89b3032f",
		"default~New-Trips-new-trips-new-trips-module~full-truck-load-ftl-container-movement-ftl-container-mo~31d88611",
		"common",
		"full-truck-load-ftl-container-movement-ftl-container-movement-module"
	],
	"../full-truck-load/ftl-list/ftl-list.module": [
		"./src/app/full-truck-load/ftl-list/ftl-list.module.ts",
		"default~full-truck-load-ftl-container-movement-ftl-container-movement-module~full-truck-load-ftl-lis~89b3032f",
		"default~New-Trips-new-trips-new-trips-module~full-truck-load-ftl-container-movement-ftl-container-mo~31d88611",
		"common",
		"full-truck-load-ftl-list-ftl-list-module"
	],
	"../full-truck-load/ftl-shipnow/ftl-shipnow.module": [
		"./src/app/full-truck-load/ftl-shipnow/ftl-shipnow.module.ts",
		"full-truck-load-ftl-shipnow-ftl-shipnow-module"
	],
	"../full-truck-load/ftldetails/ftldetails.module": [
		"./src/app/full-truck-load/ftldetails/ftldetails.module.ts",
		"default~full-truck-load-ftl-container-movement-ftl-container-movement-module~full-truck-load-ftl-lis~89b3032f",
		"common",
		"full-truck-load-ftldetails-ftldetails-module"
	],
	"../fullcalendar/fullcalendar.module": [
		"./src/app/fullcalendar/fullcalendar.module.ts",
		"fullcalendar-fullcalendar-module"
	],
	"../invoice-numbering/invoice-numbering.module": [
		"./src/app/invoice-numbering/invoice-numbering.module.ts",
		"default~Orders-by-vehicle-by-vehicle-module~Orders-pickup-req-pickupreq-entry-module~invoice-numberi~e8b11628",
		"common",
		"invoice-numbering-invoice-numbering-module"
	],
	"../lm_ReturnOrder/lm_ReturnOrder.module": [
		"./src/app/lm_ReturnOrder/lm_ReturnOrder.module.ts",
		"lm_ReturnOrder-lm_ReturnOrder-module"
	],
	"../map/WaypointsMap/Waypoints.module": [
		"./src/app/map/WaypointsMap/Waypoints.module.ts"
	],
	"../new-bid-request/new-bid-request.module": [
		"./src/app/new-bid-request/new-bid-request.module.ts",
		"new-bid-request-new-bid-request-module"
	],
	"../new-default/default.module": [
		"./src/app/new-default/default.module.ts",
		"default~new-default-default-module~new-network-new-network-module",
		"common",
		"new-default-default-module"
	],
	"../new-network/new-network.module": [
		"./src/app/new-network/new-network.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~Masters-product-rate-contract-productratecontract-module~new-network-new-network-module",
		"default~new-default-default-module~new-network-new-network-module",
		"common",
		"new-network-new-network-module"
	],
	"../new-planning/new-planning.module": [
		"./src/app/new-planning/new-planning.module.ts",
		"new-planning-new-planning-module"
	],
	"../new-ratecheck/new-ratecheck.module": [
		"./src/app/new-ratecheck/new-ratecheck.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"new-ratecheck-new-ratecheck-module"
	],
	"../new-refundpolicy/new-refundpolicy.module": [
		"./src/app/new-refundpolicy/new-refundpolicy.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"new-refundpolicy-new-refundpolicy-module"
	],
	"../new-terms-conditions/new-terms-conditions.module": [
		"./src/app/new-terms-conditions/new-terms-conditions.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"new-terms-conditions-new-terms-conditions-module"
	],
	"../newDesign/bin-replenishment/bin-replenishment.module": [
		"./src/app/newDesign/bin-replenishment/bin-replenishment.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-bin-replenishment-bin-replenishment-module"
	],
	"../newDesign/gate-management/gate-management.module": [
		"./src/app/newDesign/gate-management/gate-management.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-gate-management-gate-management-module"
	],
	"../newDesign/goods-inward/goods-inward.module": [
		"./src/app/newDesign/goods-inward/goods-inward.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-goods-inward-goods-inward-module"
	],
	"../newDesign/goods-outward/goods-outward.module": [
		"./src/app/newDesign/goods-outward/goods-outward.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-goods-outward-goods-outward-module"
	],
	"../newDesign/mwl_managelocation/mwl_generatelocationlist/mwl_generatelocationlist.module": [
		"./src/app/newDesign/mwl_managelocation/mwl_generatelocationlist/mwl_generatelocationlist.module.ts",
		"newDesign-mwl_managelocation-mwl_generatelocationlist-mwl_generatelocationlist-module"
	],
	"../newDesign/mwl_managelocation/mwl_generatelocations/mwl_generatelocations.module": [
		"./src/app/newDesign/mwl_managelocation/mwl_generatelocations/mwl_generatelocations.module.ts",
		"newDesign-mwl_managelocation-mwl_generatelocations-mwl_generatelocations-module"
	],
	"../newDesign/mwl_managelocation/mwl_locationhierarchy/mwl_locationhierarchy.module": [
		"./src/app/newDesign/mwl_managelocation/mwl_locationhierarchy/mwl_locationhierarchy.module.ts",
		"newDesign-mwl_managelocation-mwl_locationhierarchy-mwl_locationhierarchy-module"
	],
	"../newDesign/mwl_managelocation/mwl_managelocation.module": [
		"./src/app/newDesign/mwl_managelocation/mwl_managelocation.module.ts",
		"newDesign-mwl_managelocation-mwl_managelocation-module"
	],
	"../newDesign/new-bidding/new-bidding.module": [
		"./src/app/newDesign/new-bidding/new-bidding.module.ts",
		"newDesign-new-bidding-new-bidding-module"
	],
	"../newDesign/new-orders/new-orders.module": [
		"./src/app/newDesign/new-orders/new-orders.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~newDesign-new-orders-new-orders-module~newDesign-returnPurchaseOrder-returnPurchaseOrder-mod~97c4392b",
		"common",
		"newDesign-new-orders-new-orders-module"
	],
	"../newDesign/new-stock-taking/new-stock-taking.module": [
		"./src/app/newDesign/new-stock-taking/new-stock-taking.module.ts",
		"newDesign-new-stock-taking-new-stock-taking-module"
	],
	"../newDesign/new-tracking/new-tracking.module": [
		"./src/app/newDesign/new-tracking/new-tracking.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-new-tracking-new-tracking-module"
	],
	"../newDesign/newOrder/order_LTL/order_LTL.module": [
		"./src/app/newDesign/newOrder/order_LTL/order_LTL.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-newOrder-order_LTL-order_LTL-module"
	],
	"../newDesign/newpurchase-order/newpurchase-order.module": [
		"./src/app/newDesign/newpurchase-order/newpurchase-order.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-newpurchase-order-newpurchase-order-module"
	],
	"../newDesign/newsales-order/newsales-order.module": [
		"./src/app/newDesign/newsales-order/newsales-order.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-newsales-order-newsales-order-module"
	],
	"../newDesign/outward-register/outward-register.module": [
		"./src/app/newDesign/outward-register/outward-register.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-outward-register-outward-register-module"
	],
	"../newDesign/packaging/packaging.module": [
		"./src/app/newDesign/packaging/packaging.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-packaging-packaging-module"
	],
	"../newDesign/point-of-sale/point-of-sale.module": [
		"./src/app/newDesign/point-of-sale/point-of-sale.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-point-of-sale-point-of-sale-module"
	],
	"../newDesign/print-label/print-label.module": [
		"./src/app/newDesign/print-label/print-label.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-print-label-print-label-module"
	],
	"../newDesign/returnPurchaseOrder/returnPurchaseOrder.module": [
		"./src/app/newDesign/returnPurchaseOrder/returnPurchaseOrder.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~newDesign-new-orders-new-orders-module~newDesign-returnPurchaseOrder-returnPurchaseOrder-mod~97c4392b",
		"common",
		"newDesign-returnPurchaseOrder-returnPurchaseOrder-module"
	],
	"../newDesign/self-fullfilled/self-fullfilled.module": [
		"./src/app/newDesign/self-fullfilled/self-fullfilled.module.ts",
		"newDesign-self-fullfilled-self-fullfilled-module"
	],
	"../newDesign/so_KitWorkOrder/so_KitWorkOrder.module": [
		"./src/app/newDesign/so_KitWorkOrder/so_KitWorkOrder.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~newDesign-new-orders-new-orders-module~newDesign-returnPurchaseOrder-returnPurchaseOrder-mod~97c4392b",
		"common",
		"newDesign-so_KitWorkOrder-so_KitWorkOrder-module"
	],
	"../newDesign/so_KitWorkOrder/so_KitWorkOrder_form/so_KitWorkOrder_form.module": [
		"./src/app/newDesign/so_KitWorkOrder/so_KitWorkOrder_form/so_KitWorkOrder_form.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~newDesign-new-orders-new-orders-module~newDesign-returnPurchaseOrder-returnPurchaseOrder-mod~97c4392b",
		"common",
		"newDesign-so_KitWorkOrder-so_KitWorkOrder_form-so_KitWorkOrder_form-module"
	],
	"../newDesign/so_ReturnOrder/so_ReturnOrder.module": [
		"./src/app/newDesign/so_ReturnOrder/so_ReturnOrder.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-so_ReturnOrder-so_ReturnOrder-module"
	],
	"../newDesign/so_StockManagement/so_StockManagement.module": [
		"./src/app/newDesign/so_StockManagement/so_StockManagement.module.ts",
		"newDesign-so_StockManagement-so_StockManagement-module"
	],
	"../newDesign/so_StockTransfer/so_StockTransfer.module": [
		"./src/app/newDesign/so_StockTransfer/so_StockTransfer.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"default~newDesign-new-orders-new-orders-module~newDesign-returnPurchaseOrder-returnPurchaseOrder-mod~97c4392b",
		"common",
		"newDesign-so_StockTransfer-so_StockTransfer-module"
	],
	"../newDesign/so_dis_dispatch/so_dis_dispatch.module": [
		"./src/app/newDesign/so_dis_dispatch/so_dis_dispatch.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-so_dis_dispatch-so_dis_dispatch-module"
	],
	"../newDesign/so_prd_ProductReorder/so_prd_ProductReorder.module": [
		"./src/app/newDesign/so_prd_ProductReorder/so_prd_ProductReorder.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-so_prd_ProductReorder-so_prd_ProductReorder-module"
	],
	"../newDesign/warehouseLocationMaster/warehouseLocationMaster.module": [
		"./src/app/newDesign/warehouseLocationMaster/warehouseLocationMaster.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-warehouseLocationMaster-warehouseLocationMaster-module"
	],
	"../newprivacy-policy/newprivacy-policy.module": [
		"./src/app/newprivacy-policy/newprivacy-policy.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newprivacy-policy-newprivacy-policy-module"
	],
	"../newship-now/newship-now.module": [
		"./src/app/newship-now/newship-now.module.ts",
		"common",
		"newship-now-newship-now-module"
	],
	"../order-allocation-rule/order-allocation-rule.module": [
		"./src/app/order-allocation-rule/order-allocation-rule.module.ts",
		"order-allocation-rule-order-allocation-rule-module"
	],
	"../rate-check/rate-check.module": [
		"./src/app/rate-check/rate-check.module.ts",
		"rate-check-rate-check-module"
	],
	"../role-access-rights/role-access-rights.module": [
		"./src/app/role-access-rights/role-access-rights.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"role-access-rights-role-access-rights-module"
	],
	"../role-rights/role-rights.module": [
		"./src/app/role-rights/role-rights.module.ts",
		"role-rights-role-rights-module"
	],
	"../roles-new/roles-new.module": [
		"./src/app/roles-new/roles-new.module.ts",
		"roles-new-roles-new-module"
	],
	"../roles/roles.module": [
		"./src/app/roles/roles.module.ts",
		"roles-roles-module"
	],
	"../route-optimization/route-optimization.module": [
		"./src/app/route-optimization/route-optimization.module.ts"
	],
	"../routeMaster/routeMaster.module": [
		"./src/app/routeMaster/routeMaster.module.ts",
		"routeMaster-routeMaster-module"
	],
	"../starrating/starrating.module": [
		"./src/app/starrating/starrating.module.ts",
		"default~Bookings-Destination-confirm-delivery-confirm-delivery-module~starrating-starrating-module",
		"common",
		"starrating-starrating-module"
	],
	"../theme/transporter-app/new-invoice/new-invoice-list.module": [
		"./src/app/theme/transporter-app/new-invoice/new-invoice-list.module.ts",
		"theme-transporter-app-new-invoice-new-invoice-list-module"
	],
	"../wallet/wallet.module": [
		"./src/app/wallet/wallet.module.ts",
		"common",
		"wallet-wallet-module"
	],
	"./LiveTracking/LiveTracking.module": [
		"./src/app/LiveTracking/LiveTracking.module.ts"
	],
	"./LiveTracking_ByOrder/LiveTracking_ByOrder.module": [
		"./src/app/LiveTracking_ByOrder/LiveTracking_ByOrder.module.ts",
		"LiveTracking_ByOrder-LiveTracking_ByOrder-module"
	],
	"./Orders/courier-tracking/courier-tracking.module": [
		"./src/app/Orders/courier-tracking/courier-tracking.module.ts",
		"default~Bookings-Destination-gate-out-gate-out-module~Bookings-Origin-gate-in-gate-in-module~Booking~b0717e89",
		"common",
		"Orders-courier-tracking-courier-tracking-module"
	],
	"./Orders/live-order-track/live-order-track.module": [
		"./src/app/Orders/live-order-track/live-order-track.module.ts",
		"common",
		"Orders-live-order-track-live-order-track-module"
	],
	"./THCAdvanceApproveReject/THCAdvanceApproveReject.module": [
		"./src/app/THCAdvanceApproveReject/THCAdvanceApproveReject.module.ts",
		"THCAdvanceApproveReject-THCAdvanceApproveReject-module"
	],
	"./WithoutLogin/lm_orderReturnApprove/lm_orderReturnApprove.module": [
		"./src/app/WithoutLogin/lm_orderReturnApprove/lm_orderReturnApprove.module.ts",
		"WithoutLogin-lm_orderReturnApprove-lm_orderReturnApprove-module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"./beats/beats.module": [
		"./src/app/theme/transporter-app/beats/beats.module.ts",
		"default~beats-beats-module~customer-beats-beats-module",
		"common",
		"beats-beats-module"
	],
	"./check-list/check-list.module": [
		"./src/app/check-list/check-list.module.ts",
		"check-list-check-list-module"
	],
	"./components/custompassword/resetpassword.module": [
		"./src/app/components/custompassword/resetpassword.module.ts"
	],
	"./customer/beats/beats.module": [
		"./src/app/theme/new-app/customer/beats/beats.module.ts",
		"default~beats-beats-module~customer-beats-beats-module",
		"common",
		"customer-beats-beats-module"
	],
	"./customer/customer-dashboard/customer-dashboard.module": [
		"./src/app/theme/new-app/customer/customer-dashboard/customer-dashboard.module.ts",
		"customer-customer-dashboard-customer-dashboard-module"
	],
	"./customer/customer.module": [
		"./src/app/theme/new-app/customer/customer.module.ts",
		"customer-customer-module"
	],
	"./customer/invoice/invoice.module": [
		"./src/app/theme/new-app/customer/invoice/invoice.module.ts",
		"customer-invoice-invoice-module"
	],
	"./customer/payment/payment.module": [
		"./src/app/theme/new-app/customer/payment/payment.module.ts",
		"customer-payment-payment-module"
	],
	"./customer/trips/pickup-request/pickup-request.module": [
		"./src/app/theme/new-app/customer/trips/pickup-request/pickup-request.module.ts",
		"default~Bookings-dashboard-dashboard-module~Quotes-vehicle-planning-new-vehicle-planning-new-module~~bd8ff337",
		"common",
		"customer-trips-pickup-request-pickup-request-module"
	],
	"./customer/trips/trips.module": [
		"./src/app/theme/new-app/customer/trips/trips.module.ts",
		"customer-trips-trips-module"
	],
	"./email/email.module": [
		"./src/app/theme/home/email/email.module.ts",
		"email-email-module"
	],
	"./home/home.module": [
		"./src/app/theme/home/home.module.ts",
		"default~home-home-module~signup-signup-module",
		"default~home-home-module~login-login-module",
		"common",
		"home-home-module"
	],
	"./home/home1.module": [
		"./src/app/theme/home/home1.module.ts",
		"common",
		"home-home1-module"
	],
	"./invoice/invoice.module": [
		"./src/app/theme/transporter-app/invoice/invoice.module.ts",
		"invoice-invoice-module"
	],
	"./login/customer/customer.module": [
		"./src/app/theme/home/login/customer/customer.module.ts",
		"login-customer-customer-module"
	],
	"./login/forgot-password/forgot-password.module": [
		"./src/app/theme/home/login/forgot-password/forgot-password.module.ts",
		"login-forgot-password-forgot-password-module"
	],
	"./login/login.module": [
		"./src/app/theme/home/login/login.module.ts",
		"default~home-home-module~login-login-module",
		"common",
		"login-login-module"
	],
	"./login/transporter/transporter.module": [
		"./src/app/theme/home/login/transporter/transporter.module.ts",
		"login-transporter-transporter-module"
	],
	"./main/main.module": [
		"./src/app/theme/home/main/main.module.ts",
		"main-main-module"
	],
	"./new-app/new-app.module": [
		"./src/app/theme/new-app/new-app.module.ts",
		"new-app-new-app-module"
	],
	"./new-terms-conditions/new-terms-conditions.module": [
		"./src/app/new-terms-conditions/new-terms-conditions.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"new-terms-conditions-new-terms-conditions-module"
	],
	"./newDesign/new-tracking/new-tracking.module": [
		"./src/app/newDesign/new-tracking/new-tracking.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newDesign-new-tracking-new-tracking-module"
	],
	"./newprivacy-policy/newprivacy-policy.module": [
		"./src/app/newprivacy-policy/newprivacy-policy.module.ts",
		"default~Accouting-new-manage-cess-new-manage-cess-module~Accouting-new-manage-taxes-new-manage-taxes~59ec5795",
		"common",
		"newprivacy-policy-newprivacy-policy-module"
	],
	"./pages/default/customer-dashboard/customer.module": [
		"./src/app/theme/pages/default/customer-dashboard/customer.module.ts",
		"pages-default-customer-dashboard-customer-module"
	],
	"./pages/default/dashboard/dashboard.module": [
		"./src/app/theme/pages/default/dashboard/dashboard.module.ts",
		"pages-default-dashboard-dashboard-module"
	],
	"./pages/default/exception-dashboard/exception.module": [
		"./src/app/theme/pages/default/exception-dashboard/exception.module.ts",
		"pages-default-exception-dashboard-exception-module"
	],
	"./pages/default/management/management.module": [
		"./src/app/theme/pages/default/management/management.module.ts",
		"pages-default-management-management-module"
	],
	"./pages/default/transporter-dashboard/transporter.module": [
		"./src/app/theme/pages/default/transporter-dashboard/transporter.module.ts",
		"pages-default-transporter-dashboard-transporter-module"
	],
	"./payments/payments.module": [
		"./src/app/theme/transporter-app/payments/payments.module.ts",
		"payments-payments-module"
	],
	"./print-invoice/print-invoice.module": [
		"./src/app/print-invoice/print-invoice.module.ts"
	],
	"./signup/signup-customer/signup-customer.module": [
		"./src/app/theme/home/signup/signup-customer/signup-customer.module.ts",
		"signup-signup-customer-signup-customer-module"
	],
	"./signup/signup-transporter/signup-transporter.module": [
		"./src/app/theme/home/signup/signup-transporter/signup-transporter.module.ts",
		"signup-signup-transporter-signup-transporter-module"
	],
	"./signup/signup.module": [
		"./src/app/theme/home/signup/signup.module.ts",
		"default~home-home-module~signup-signup-module",
		"common",
		"signup-signup-module"
	],
	"./testPage/testPage.module": [
		"./src/app/testPage/testPage.module.ts",
		"testPage-testPage-module"
	],
	"./theme/NewLogin/newloginpage/newloginpage.module": [
		"./src/app/theme/NewLogin/newloginpage/newloginpage.module.ts",
		"theme-NewLogin-newloginpage-newloginpage-module"
	],
	"./track-by-no/track-by-no.module": [
		"./src/app/track-by-no/track-by-no.module.ts"
	],
	"./transporter-app/transporter-app.module": [
		"./src/app/theme/transporter-app/transporter-app.module.ts",
		"transporter-app-transporter-app-module"
	],
	"./trip-planning-map/trip-panning-map.module": [
		"./src/app/trip-planning-map/trip-panning-map.module.ts",
		"trip-planning-map-trip-panning-map-module"
	],
	"./trips/trips.module": [
		"./src/app/theme/transporter-app/trips/trips.module.ts",
		"trips-trips-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;